
import '../App.css';
import * as React from 'react';
import {useState, useEffect, useRef} from 'react';
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import { ethers } from 'ethers';
import $ from 'jquery';
import axios from 'axios';
// Navbar components
	import { checkWalletStatus, getPreviousWallets, checkPreviousWalletExists, subscribeToWallets, listenForAccountChanges, listenForChainChanges, connectWallet, switchNetwork, switchNavConnectButtonText, mainButtonSwitcher, bchainCheckAndButtonControl } from '../ResponsiveAppBar';
import { hashData, hashSolidityStyle } from './Create';
import DOMPurify from 'dompurify';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';

import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';
// import Container from '@mui/material/Container';
import { Box, TextField, Button, List, ListItem, Typography } from "@mui/material";
import { Fade } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import InfoIcon from '@mui/icons-material/Info';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import HelpOutline from '@mui/icons-material/HelpOutline';

// Collapsible table
	import PropTypes from 'prop-types';
	import Collapse from '@mui/material/Collapse';
	import IconButton from '@mui/material/IconButton';
	import Paper from '@mui/material/Paper';
	import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
	import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import copy from 'copy-to-clipboard';

// Blockchain 
	import ProjectType1 from '../artifacts/contracts/ProjectType1.sol/ProjectType1.json';
import { SignalCellularNoSimOutlined } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import { id } from 'ethers/lib/utils';

// Set base URLs & IDs
	let CONTRACT_ADDRESS, USER_API_ENDPOINT_ROOT, PROVIDER_URL, API_ENDPOINT_ROOT, TEAMS_API_ENDPOINT_ROOT, TEAMS_URL_BASE, USER_PROFILE_URL_BASE, UPLOADS_FOLDER, UPLOADS_FOLDER_URL, ASSETS_FOLDER, BLOCK_EXPLORER_URL, NETWORK_CHAIN_ID;

	if (process.env.NODE_ENV === "development") {
		console.log("local environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_LOCAL;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_LOCAL;
		PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_LOCAL; // Alchemy
		API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_LOCAL;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_LOCAL;
		TEAMS_URL_BASE = process.env.REACT_APP_TEAMS_URL_BASE_LOCAL;
		// USER_PROFILE_URL_BASE = process.env.REACT_APP_USER_PROFILE_URL_BASE_LOCAL;
		UPLOADS_FOLDER = process.env.REACT_APP_UPLOADS_FOLDER_LOCAL;
		UPLOADS_FOLDER_URL = process.env.REACT_APP_UPLOADS_FOLDER_URL_LOCAL;
		ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_LOCAL;
		BLOCK_EXPLORER_URL = process.env.REACT_APP_BLOCK_EXPLORER_URL_LOCAL;
		NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;     
	} else {
		console.log("production environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_PRODUCTION;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_PRODUCTION;
		PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_PRODUCTION; // Alchemy
		API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_PRODUCTION;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_PRODUCTION;
		TEAMS_URL_BASE = process.env.REACT_APP_TEAMS_URL_BASE_PRODUCTION;
		// USER_PROFILE_URL_BASE = process.env.REACT_APP_USER_PROFILE_URL_BASE_PRODUCTION;
		UPLOADS_FOLDER = process.env.REACT_APP_UPLOADS_FOLDER_PRODUCTION;
		UPLOADS_FOLDER_URL = process.env.REACT_APP_UPLOADS_FOLDER_URL_PRODUCTION;
		ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_PRODUCTION;
		BLOCK_EXPLORER_URL = process.env.REACT_APP_BLOCK_EXPLORER_URL_PRODUCTION;
		NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;  
	}

// Set project restriction hashes
	// const restrictionPublicHash = "0x3c0c3a2537aaf75b853bbf2b595e872d3db0359b7e792ebd8907fb017c3b71a2";
	// const restrictionPrivateHash = "0xba0b8d7971d83a895b04f69bb35eb4161849cc1e4886c0eec88858e4667ebaae";
	const restrictionOpenHash = "0x99f30275ab70dd1890c0789c4570632b6f0b0284d11c2d9e587d0368f7027018";
	const restrictionSoloHash = "0xba0b8d7971d83a895b04f69bb35eb4161849cc1e4886c0eec88858e4667ebaae"; // Currently same as private - change later

// Global variables / objects
	let userAuthInfo_global = {
		account: null,
		message: null,
		signature: null
	};

	let onLoad_global = false;

// PROXY trigger
	// Proxy variables (GLOBAL)
	let proxy;
	let proxyVar;
	let recoonectInSkipMode_global = false;
	// Reset blockchain connection
	export function resetConnection2(_mode = null) {
		console.log("resetConnection2 triggered");
		if (_mode == 'skip wallet prompt') {
			recoonectInSkipMode_global = true;
		} else {
			recoonectInSkipMode_global = false;
		}
		let randomNumber = Math.random();
		proxy.proxyVar = randomNumber;
	}

// Loading icon
	export function controlLoadingIcon(_state) {
		if (_state == "loading") {
			$("#loading-motion-1").show();
			let loadingImgURL = ASSETS_FOLDER + 'loading.gif';
			$("#loading-motion-1").append("<img width='70px' src='" +loadingImgURL+ "' style='margin-top: -15px;' />");
			$(".header-texts").hide();
		} else if (_state == "default") {
			$("#loading-motion-1").find("img").remove();
			$("#loading-motion-1").hide(); 
			$(".header-texts").show(); 
		}
	}
	export function controlLoadingIcon_2(_state) {
		if (_state == "loading") {
			$("#loading-motion-2").show();
			let loadingImgURL = ASSETS_FOLDER + 'loading.gif';
			$("#loading-motion-2").append("<img width='70px' src='" +loadingImgURL+ "' style='margin-top: -15px;' />");
			$(".header-texts").hide();
		} else if (_state == "default") {
			$("#loading-motion-2").find("img").remove();
			$("#loading-motion-2").hide(); 
			$(".header-texts").show(); 
		}
	}

// Other functions

	export function getURLParameter(_paramName) {
		// Get URL query
			let URLquery = window.location.search.substring(1);
		// Split parameters (incase of multiple parameters)
			let paramArray = URLquery.split('&');
			let parameter;
		for (let i = 0; i < paramArray.length; i++) {
			parameter = paramArray[i].split('=');
			if (parameter[0] == _paramName) {
				return decodeURIComponent(parameter[1]);
			}
			if (i == (paramArray.length - 1)) {
				return "empty";
			}
		}
	}

	export function deleteURLanchor(_pageURL = null) {
		let pageURL
		if (!_pageURL) {
			pageURL = window.location.href;
		} else {
			pageURL = _pageURL;
		}
		pageURL = _pageURL.split('#');
		pageURL = pageURL[0];
		console.log("pageURL: " + pageURL);
		return pageURL;
	}

	export async function getCurrentUNIXTime() {
		const currentTimeUnix = Math.floor(Date.now());
		return currentTimeUnix;
	}

	// Function to convert readable time ("yyyy-mm-dd hh:mm:ss") to UNIX time
	export function convertToUNIXTime(_dateString) {
		let _date = new Date(_dateString + 'Z'); // 'Z' is for UTC time
		let _unixTime = _date.getTime();
		return _unixTime;
	}

	// Make Project Reference Number from project key (take first & last 4 characters and combine them with a hyphen, ingore "0x")
	export function makeProjectRefNumber(_projectKey) {
		let _projectKeyStr = _projectKey.toString();
		let _projectKeyStrLength = _projectKeyStr.length;
		let _first4 = _projectKeyStr.slice(2, 6);
		let _last4 = _projectKeyStr.slice(_projectKeyStrLength - 4, _projectKeyStrLength);
		let _projectRefNumber = _first4 + '-' + _last4;
		return _projectRefNumber;
	}

	// Takes a hash (SHA-256) and a string, hash the latter and compare it with the former
	export async function compareHash(_hash, _string) {
		let hashedString = await hashData(_string);
		if (hashedString == _hash) {
			return true;
		} else {
			return false;
		}
	}

	// Takes a hash (SHA-256) and an image address, hash the latter and compare it with the former
	export async function validateFileHash(_hash, _fileAddr) {
		return new Promise((resolve, reject) => {
			let postData = {
				file_address: _fileAddr,
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "hash-function.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				console.log("Hashing result: ", res.data.hash);
				if (res.data.hash != _hash) {
					resolve(false);
				} else {
					resolve(true);
				}
			}) 
			.catch((err) => { console.log("error response: " + err);
			});
		});
	}

	export async function requestAccount() {
		console.log("requestAccount() triggered");
		let bc_account;
		try {
			let wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
			bc_account = wallet_accounts[0];

			if (typeof bc_account === "undefined") {
				wallet_accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
				bc_account = wallet_accounts[0];
			}
			// Check again
			if (typeof bc_account === "undefined") {
				bc_account = "error";
			}
			console.log("bc_account: " + bc_account);

			return bc_account

		} catch(err) {
			console.log("Error: ", err);
			return "error"
		}
	}

	// Get ONCHAIN user information from user registry DB
	export async function getUserInfoFromDB(_key, _keyType) { // blockchain, email or username
		console.log("function getUserInfoFromDB triggered * * * : " + _key + ", " + _keyType);

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'query',
				query_type: 'latest',
				key: _key, // blockchain, email or username
				key_type: _keyType // 'email', 'bockchain', 'username', 'combined'
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Check returned_data (user registry): ", returned_data);
				resolve(returned_data);
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}

	// Get OFFCHAIN user information from user_registry_offchain DB
	export async function getUserInfoFromDB_offchain(_key, _keyType) { // username or email address
		console.log("function getUserInfoFromDB_offchain triggered * * * : " + _key + ", " + _keyType);

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'query',
				query_type: 'latest',
				key: _key, // username or email address
				key_type: _keyType // 'username', 'email', or 'combined'
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry-offchain.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Check returned_data (user-registry-offchain): ", returned_data);
				resolve(returned_data);
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}

	// Get project submission count from DB

	export async function getProjectSubmissionCountFromDB(_projectKey) { 
		console.log("getProjectSubmissionCount triggered: " + _projectKey);

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'submission_count',
				project_key: _projectKey,
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Submission count (ON-chain): " + returned_data.on_chain_count);
				console.log("Submission count (OFF-chain): " + returned_data.off_chain_count);
				console.log("Submission total count: " + returned_data.total_count);

				resolve(returned_data);
			}) 
			.catch((err) => { 
				console.log("ERROR response: ", err);
			});
		});
	}




// - - - - - - - - - - -

export default function Project() {

	const [openEdit, setOpenEdit] = useState(false);

	// const [rows_state, setRows_state] = useState([]);
	const [projectKey_state, setProjectKey] = useState(null);
	const [projManagerAddressDB_state, setProjManagerAddressDB_state] = useState("");
	const [managerURL_state, setManagerURL] = useState("");
	const [userIsManager_state, setUserIsManager] = useState(false);
	const [userAddress, setUserAddress] = useState(null);
	const [teamProject_state, setTeamProject] = useState(false);
	const [soloProject_state, setSoloProject] = useState(false);
	const [openProject_state, setOpenProject] = useState(false);
	const [teamURL_state, setTeamURL] = useState(null);

	const [privateStatus_state, setPrivateStatus_state] = useState(false);
	// const [userSigMessage_state, setUserSigMessage] = useState("");
	// const [userSignature_state, setUserSignature] = useState("");

	const [privacyText_state, setPrivacyText_state] = useState("");
		const [privacyTextSoloON_state, setPrivacyTextSoloON_state] = useState("This project is visible to you only. ");
		const [privacyTextTeamON_state, setPrivacyTextTeamON_state] = useState("This project is visible to the team only. ");
		const [privacyTextOpenON_state, setPrivacyTextOpenON_state] = useState("This project is visible to manager only. ");
		const [privacyTextOFF_state, setPrivacyTextOFF_state] = useState("This project is visible to all. ");

	const [projectInfo_onchain, setProjectInfo_onchain] = useState("------");
	const [projectInfo_offchain, setProjectInfo_offchain] = useState("------");
	const [projectRefNumber, setProjectRefNumber] = useState("------");
	const [finalManagerName, setFinalManagerName] = useState("------");
	const [projectClosed, setProjectClosed] = useState(false);
	const [projectWaiting, setProjectWaiting] = useState(false);
	const [notConnectedToBchain, setNotConnectedToBchain] = useState(false);

	const [projTxnURL, setProjTxnURL] = useState(""); // was null
	const [submissionArray, setSubmissionArray] = useState(""); // was null

	const [feedbackShown, setFeedbackShown] = useState(false);
	const [projectFeedback_offchain, setProjectFeedback_offchain] = useState(null);
	const [feedbackTitle, setFeedbackTitle] = useState("------");
	const [feedbackTasking, setFeedbackTasking] = useState("------");
	const [feedbackFilename, setFeedbackFilename] = useState("------");

	const [submissionsArrayDB, setSubmissionsArrayDB] = useState('');
	const [justSubmittedReadableTime, setJustSubmittedReadableTime] = useState("");
	const [showLatestSubmission, setShowLatestSubmission] = useState(false);
	// const [rowOpen, setRowOpen] = useState(false);

	const [fileHash, setFileHash] = useState('');
	const [projectTxHash, setProjectTxHash] = useState(""); // was null
	const [submissionTxHash, setSubmissionTxHash] = useState(""); // was null

	const [registerUser, setRegisterUser] = useState(false);
	const [passwordCheckStatus, setPasswordCheckStatus] = useState('off'); // on, off, valid, invalid
	const [keepUserInputFieldsVisible, setKeepUserInputFieldsVisible] = useState(false);

	const [newUsername, setNewUsername] = useState('');
	const [newUserPassword, setNewUserPassword] = useState('');
	const [newUserEmail, setNewUserEmail] = useState('');

	const [errorPsiSubmissionText, setErrorPsiSubmissionText] = useState(false);
	const [errorNewUsername, setErrorNewUsername] = useState(false);
	const [errorNewUserPassword, setErrorNewUserPassword] = useState(false);
	const [errorNewUserEmail, setErrorNewUserEmail] = useState(false);

	const [psiSubmissionText, setPsiSubmissionText] = useState("");
	const [predictFileAddr, setFileAddr] = useState(null);
	const [fileHashValid, setFileHashValid] = useState(true);

	const [cfmMode, setCfmMode] = useState(false);
	const [copyText, setCopyText] = useState('Copy URL & Share');
	const [isExpanded, setIsExpanded] = useState(false);

	// For file upload
		const [fileSelected, setFile] = useState('');
		const [fileUploading, setFileUploading] = useState(false);
		const [fileUploaded, setFileUploaded] = useState(false);
		const [fileNameFinal, setFileNameFinal] = useState(null);

		const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
		const [skipBlockchain, setSkipBlockchain] = useState(false); 

		const [rows2, setRows2] = useState([]);

		const infoHashingFile = "Only the 'hash', or the cryptographic 'fingerprint', of the file will be stored on blockchain. The file itself will be stored on an off-chain server.";

		const userSubmissionsTable = useRef(null);

	// For visibility of "main boxes"
		const [mainBoxesVisible, setMainBoxesVisible] = useState(true); 

	// For Update & URL Notes
		// const [showUpdateEditBox, setShowUpdateEditBox] = useState(false);
		const [showUpdateBox, setShowUpdateBox] = useState(false);
		const [updateText, setUpdateText] = useState("");
		const [urlNotesArray, setUrlNotesArray] = useState([]);
		const [urlNoteForm, setUrlNoteForm] = useState({ link: "", note: "" });
		const [editingIndex, setEditingIndex] = useState(null);

	// PROXY setup (Keep track of proxyVar for function trigger)
		// Proxy handler
		let proxyHandler = {
			set: function(target, property, value) {
				target[property] = value;
				// On variable change...
				if (recoonectInSkipMode_global == true) {
					setupBlockchain('skip wallet prompt');
				} else {
					setupBlockchain();
				}
				return true;
			}
		};
		// Create a proxied variable which triggers above function on change
		proxy = new Proxy({ proxyVar: proxyVar }, proxyHandler);

	// Show header's project status note on page load with slight delay (to avoid showing alert text in red)
		useEffect(() => {
			setTimeout(function() {
				$(".header-status-note").show(300);
			}, 1500); // delay of 1.5 sec
		}, []);


	// For scrolling to a section
		const sectionRef = useRef(null);
		const handleScroll = () => {
			sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
		};

	// Check if user is manager (added June 2025)
		async function checkIfUserIsManager() { 

			console.log("checkIfUserIsManager() triggered");
			let userIsManager_ = false;

			// This function requires using projManagerAddressDB_state
				if (!projManagerAddressDB_state) {
					console.log("No project manager address found in state");
					alert("Error: Project manager address not found.");
					return false; // No manager address available
				}
			// Get user blockchain account
				const bchain_account_ = await requestAccount();
				if (bchain_account_ == "error") {
					console.log("bc_account request failed");
					return false;
				}
			// Compare manager address with user address
				if (bchain_account_.toLowerCase() == projManagerAddressDB_state.toLowerCase()) {
					userIsManager_ = true;
					console.log("User is the project manager");
				} else {
					console.log("User is NOT the project manager");
				}

			setUserIsManager(userIsManager_);
			return userIsManager_;
		}

	// Get user siguature via wallet and authenticate (added June 2025)
		async function getSignatureAndAuthenticateUser() { 
			console.log("getSignatureAndAuthenticateUser() triggered");
			let userAuthInfo, userIsAuthenticated;

			// Get user blockchain account
				const bchain_account_ = await requestAccount();
				console.log("Check bchain_account_: ", bchain_account_);
				if (bchain_account_ == "error") {
					console.log("bc_account request failed");
				}

			// Have user sign notification + random string
				const provider = new ethers.providers.Web3Provider(window.ethereum);
				const signer = provider.getSigner();

				const message_ = "This is a quick and standard 'Web3' way of verifying your identity. (Needed because only the project manager is allowed to change the Privacy setting.) No transaction fees involved. Simply click the button and the system will take care of the rest. Authentification code ('nonce'): "
				
				const randomMessage = message_ + Math.random().toString(36).substring(2);
				console.log("Check randomMessage: ", randomMessage);
				
				let signature;
				try {
					signature = await signer.signMessage(randomMessage);
				} catch(err) {
					console.log("Error: ", err);
					alert("Error! Could not sign message. Please try again.");
					userAuthInfo = "error";
					return userAuthInfo;
				}
				// console.log("Check user signature: ", signature);

				const signatureInfo = {
					account: bchain_account_,
					message: randomMessage,
					signature: signature
				}

			// Authenticate user with signature
				try {
					const res = await axios({
						url: API_ENDPOINT_ROOT + "authenticate-user.php",
						method: "POST",
						data: JSON.stringify(signatureInfo),
					});
			
					console.log("User authentication result: ", res.data.result);
					userIsAuthenticated = res.data.result;

					// If authentication result recieved...
					if (userIsAuthenticated && userIsAuthenticated !== 'error') {
						if (userIsAuthenticated == true) {
							console.log("User authenticated");
						} else if (userIsAuthenticated == false) {
							alert("Invalid user!");
							userAuthInfo = "error";
							return userAuthInfo;
						}
					} else {
						console.log("User authentication error");
						alert("User authentication error!");
						userAuthInfo = "error";
						return userAuthInfo;
					}
				} catch (err) {
					console.log("error response: ", err);
					alert("Server error!");
					userAuthInfo = "error";
					return userAuthInfo;
				}

			// Make user authentication info object by combining signatureInfo & userIsAuthenticated
			userAuthInfo = {
				account: signatureInfo.account,
				message: signatureInfo.message,
				signature: signatureInfo.signature,
				authenticated: userIsAuthenticated // true, false, or "error"
			};
			// console.log("Check userAuthInfo: ", userAuthInfo);

			return userAuthInfo;
		}


	// For URL Notes

		const handleUpdateBoxSwitch = async () => {
			console.log("handleUpdateBoxSwitch triggered");

			// Get signature, message, and authenticate user
				const userSignatureInfo = await getSignatureAndAuthenticateUser();
				if (userSignatureInfo == "error") {
					console.log("userSignature request failed");
					alert('userSignature request failed')
					return;
				}
			// Toggle the visibility of the update box
				setShowUpdateBox(prev => !prev);

			// Get project key from URL
				const projectKey_ = getURLParameter('key');

			return new Promise((resolve, reject) => {
				let postData = {
					type: 'proj_update',
					project_key: projectKey_,
					bchain_account: userAddress,
					message: userSignatureInfo.message,
					signature: userSignatureInfo.signature,
					update_status: !showUpdateBox // toggle the status
				};
				console.log('Check postData: ', postData);
				axios({ 
					url: API_ENDPOINT_ROOT + "store-data-db.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					const returned_data = res.data.result;
					console.log("Check returned_data: ", returned_data);
					if (returned_data == 'success') {
						console.log('DB insertion successful')
						resolve(returned_data);
					} else { 
						console.log("Could not insert data to DB!");
						alert('Could not insert data to DB!')
						resolve(null); 
					}
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
					alert('Error!');
				});
			});
		};

		const handleUpdateTextFormChange = (e) => {
			setUpdateText(e);
		};

		const handleLinkFormChange = (e) => {
			setUrlNoteForm({ ...urlNoteForm, [e.target.name]: e.target.value });
		};

		const handleLinkFormSubmit = async (e) => {
			e.preventDefault();

			let updatedNotes;
			if (editingIndex !== null) {
				updatedNotes = [...urlNotesArray];
				updatedNotes[editingIndex] = urlNoteForm;
				console.log("Updated notes: ", updatedNotes);
				setEditingIndex(null);
			} else {
				updatedNotes = [...urlNotesArray, urlNoteForm];
				console.log("updatedNotes: ", updatedNotes);
			}
			setUrlNotesArray(updatedNotes);
			setUrlNoteForm({ link: "", note: "" });
		};

		const handleEdit = (index) => {
			setUrlNoteForm(urlNotesArray[index]);
			setEditingIndex(index);
		};

		const handleDelete = async (index) => {
			const updatedNotes = urlNotesArray.filter((_, i) => i !== index);
			setUrlNotesArray(updatedNotes);
		};

		const handleProjectUpdateSubmit = async () => {
			console.log("handleProjectUpdateSubmit triggered");
			console.log("Check updateText: ", updateText);
			console.log("Check urlNotesArray: ", urlNotesArray);

			if (!updateText || updateText.trim() === "") {
				// alert("Please enter Update text.");
				// return;
			}

			// Get project key from URL
				const projectKey_ = getURLParameter('key');
			// Sign random message
				// Get signature, message, and authenticate user
				const userSignatureInfo = await getSignatureAndAuthenticateUser();
				if (userSignatureInfo == "error") {
					console.log("userSignature request/authentication failed");
					return;
				}

			return new Promise((resolve, reject) => {
				let postData = {
					type: 'project_update_info',
					project_key: projectKey_,
					update_text: updateText,
					url_notes: urlNotesArray,
					bchain_account: userSignatureInfo.account,
					message: userSignatureInfo.message,
					signature: userSignatureInfo.signature,
				};
				axios({ 
					url: API_ENDPOINT_ROOT + "store-data-db.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					const returned_data = res.data.result;
					console.log("Check returned_data: ", returned_data);
					if (returned_data && returned_data !== 'error' && returned_data !== 'forbidden' ) {
						// setUpdateText(null);
						console.log("Project update submitted successfully");
						setOpenEdit(prev => !prev);
						handleScroll();
						resolve(returned_data);
					// } else { 
					// 	console.log("Could not insert data to DB!");
					// 	resolve(null); 
					// }
					} else if (returned_data == 'error' || !returned_data) {
						console.log("error");
						alert("Failed to save!");
						resolve(null); 
					} else if (returned_data == 'forbidden') {
						console.log("forbidden");
						alert("You are not allowed to make changes to Update.");
						resolve(null); 
					}
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
			});
		}



	// Reset everything in user sumbission input section
		function resetUserSubmissionInputSection() {

			console.log("resetUserSubmissionInputSection() triggered");

			resetSubmissionPreferenceArea(); // function
			setPsiSubmissionText("");
			setErrorPsiSubmissionText(false);

			setFile('');
			setFileUploading(false);
			setFileUploaded(false);
			setFileNameFinal(null);
			setFileHashValid(true);
			setFileHash('');

			setSubmitBtnDisabled(false);
			setSkipBlockchain(false);
			setPasswordCheckStatus("off");
			setKeepUserInputFieldsVisible(false);

			// Reset alert area
				$(".user-bchain-unrecognized").hide(300);
				$(".username-unavailable").hide(300);
				$(".user-email-unavailable").hide(300);
				$(".username-unavailable-check-pw").hide(300);
				$(".user-password-incorrect").hide(300);
				$(".onchain-user-pw-check-fail").hide(300);
				$(".password-field").hide(300);

			// Reset file upload area [this is also in $(".file_remove").on("click"...]
				$("#uploaded_view").removeClass("show");
				$("#uploaded_view").find("img").remove();
				$("#uploaded_view").find("p").remove(); // file name
				btnOuter.removeClass("file_uploading");
				btnOuter.removeClass("file_uploaded");
				$(".button_outer").show();
				$(".upload_button").hide();
				$("#loading-motion-1").find("p").remove();
				$("#loading-motion-1").hide(); 
				$(".vertical-adj-1").hide();
				$("#file-hashing-info").hide();
				setSubmitBtnDisabled(false);
				setFile(''); // clear state variable
				setFileHash('') // clear state variable
		}

	// Check user's credentials for viewing private projects
		async function checkUserCredentialsForPrivateInfo() {

			console.log("checkUserCredentialsForPrivateInfo() triggered - - - - - - - -");
			console.log("Check projectKey_state: " + projectKey_state);
			console.log("Check userAddress: " + userAddress);
			console.log("Check teamProject_state: " + teamProject_state);
			console.log("Check privateStatus_state: " + privateStatus_state);

			// Check if it's team project, if so, check if user is in the team
				if (teamProject_state == true) {
					const isTeamMember = await checkTeamMembership();
					if (isTeamMember == false) {
						$("#bchain-progress").hide(); // JIC
						mainButtonSwitcher('bchain'); // JIC
						alert("Your team membership could not be verified. Submission not accepted.");
						return; // stop txn
					} else {
						console.log("User is a team member");
					}
				}

			// If project is private and not for team, check if user is manager
				if (privateStatus_state == true && teamProject_state == false) {
					const userIsManager = await compareMangerAndUserAddressesThenManageSettingSwitch(projManagerAddressDB_state, projectKey_state, privateStatus_state);
					if (userIsManager == false) {
						$("#bchain-progress").hide(); // JIC
						mainButtonSwitcher('bchain'); // JIC (added 1/22/25)
						alert("Project manager has made this project 'private'. Only manager has access at this time.");
						return; // stop txn
					}
				}

			// Get user signature via wallet and authenticate
				const userAuthentication = await getSignatureAndAuthenticateUser();
				console.log("Check userAuthentication: ", userAuthentication);
				const userIsAuthenticated = userAuthentication.authenticated;

				if (userIsAuthenticated && userIsAuthenticated !== 'error') {
					// If authentication result recieved...
					if (userIsAuthenticated == true) {
						console.log("User authenticated");
						await switchSigRequestMode("off");

						userAuthInfo_global = {
							account: userAuthentication.account,
							message: userAuthentication.message,
							signature: userAuthentication.signature
						}
						console.log("userAuthInfo_global: ", userAuthInfo_global);
						
						await setupBlockchain('skip wallet prompt');

					} else if (userIsAuthenticated == false) {
						// setUserSigMessage("");
						// setUserSignature("");
						switchSigRequestMode("on");
						alert("Invalid user!");
					}
					return userIsAuthenticated;

				} else {
					console.log("User authentification error");
					switchSigRequestMode("on");
					alert("User authentification error!");
					return "error";
				}
		}

	// Compare manager address & user address, then show/hide 'setting-switch' (in pravacy & Update boxes)
		async function compareMangerAndUserAddressesThenManageSettingSwitch(_managerAddress, _restriction, _privacyOn) {

			console.log("- - - - compareMangerAndUserAddressesThenManageSettingSwitch triggered");
			console.log("_managerAddress: " + _managerAddress);
			console.log("_restriction: " + _restriction);
			console.log("_privacyOn: " + _privacyOn);

			// Check wallet connection status
				const userWalletStatus = await checkWalletStatus();
			// Get user address
				let userAddress_;
				if (userWalletStatus.walletConnected == true) {
					userAddress_ = await requestAccount();
					console.log("Check userAddress_: " + userAddress_);
				} else {
					userAddress_ = "error";
				}
			// If user address is not found
				$(".privacy-box").hide(); // reset
				if (!userAddress_ || userAddress_ == "error") {
					console.log("userAddress_ = 'emtpy'");
					userAddress_ = "empty";
					$(".privacy-box").show(); 
					$(".setting-switch").hide();
				}
			// If user address is found, compare it with manager address
				let userIsManager;
				if (userAddress_ != "empty") {
					console.log("User address found");
					if (userAddress_.toLowerCase() == _managerAddress.toLowerCase()) {
						console.log("User is manager - show privacy box & switch");
						$(".privacy-box").show(); 
						$(".setting-switch").show();
						userIsManager = true;
					} else {
						console.log("User is not manager - show privacy box without switch");
						$(".privacy-box").show(); 
						$(".setting-switch").hide();
						userIsManager = false;
					}
				} else {
					userIsManager = false;
				}
				console.log("userIsManager: " + userIsManager);
				setUserIsManager(userIsManager); // set state variable

			return userIsManager;
		}


	// Connect to blockchain - via wallet or Alchemy
	
		async function setupBlockchain(_mode = null) {

			console.log("= = = = setupBlockchain() triggered = = = =");
			// setShowLatestSubmission(false); // reset JIC
			console.log("Check mode param: " + _mode);

			if (keepUserInputFieldsVisible == false) { 
				$(".user-info-input-section").hide(300); // reset
				setRegisterUser(false); // reset
			} else {
				setKeepUserInputFieldsVisible(false); // reset
			}

			// Get user address & set state variable
				if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
					console.log("Wallet is installed");
					const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
					const walletAccount1 = wallet_accounts[0];
					console.log("blockchain account: " + walletAccount1);
					if (walletAccount1) { 
						console.log("User connected to wallet");
						setUserAddress(walletAccount1);
					}
				}

			// Check if user is connected to blockchain & manage button
				try {
					await bchainCheckAndButtonControl(_mode);
				} catch(err) {
					console.log("Error: ", err);
				}

				// return; // testing here / temp (1/24/25)

			// Get data from DB
				if (_mode !== "noDataRetrieval") {
					console.log("Start retrieving data");
					getModeAndKeyParamsThenTxnFromDB();
				} else if (_mode == "noDataRetrieval") {
					console.log("No data retrieval");
				}
		} 
		// End of setupBlockchain


		async function setupContract() {

			console.log("= = = = setupContract() triggered");

			// Check user connection to blockchain
				console.log("Call checkWalletStatus()");
				const connectionStatus = await checkWalletStatus();
					// Returned values (object) - walletInstalled, walletConnected, walletAccount, correctChain, allSet
				console.log("connectionStatus: ", connectionStatus);

			// Wallet
				let contract_wallet;
				if (connectionStatus.allSet == true) {
					const provider_wallet = new ethers.providers.Web3Provider(window.ethereum);
					const signer_wallet = provider_wallet.getSigner();
					contract_wallet = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, signer_wallet);
				}
			// API (Alchemy)
				const provider_api = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
				const contract_api = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider_api);

			let contract_primary, contract_secondary;
			if (connectionStatus.allSet == true) {
				console.log("Use wallet as provider");
				contract_primary = contract_wallet;
				contract_secondary = contract_api;
			} else {
				console.log("Use Alchemy as provider");
				contract_primary = contract_api;
				contract_secondary = contract_api;
			}

			return [contract_primary, contract_secondary];
		}

		// Triggered on page load * * *

			useEffect(() => {
				// Check for URL anchor - reload page if found
					let page_URL = window.location.href;
					let URL_anchor = page_URL.split('#');
					if (URL_anchor[1]) { // If found...
						let fixedURL = deleteURLanchor(page_URL);
						window.location.replace(fixedURL);
						return;
					}
				onLoad_global = true;
				console.log("setupBlockchain() triggered on page load");
				setupBlockchain('on load'); // * * * * * *
			}, []);

	// End of section for connecting to blockchain


// Project info retrieval section - - - -

	async function getModeAndKeyParamsThenTxnFromDB() {
		console.log("getModeAndKeyParamsThenTxnFromDB triggered");
		console.log('Get URL parameters');
		let _key = getURLParameter('key');
		let _cfm = getURLParameter('cfm');
		// Set project key & reference #
			setProjectKey(_key);
			setProjectRefNumber(makeProjectRefNumber(_key));

		if (_cfm == "empty") { // If in normal mode

			console.log("Project page - normal mode");
			setCfmMode(false);

			const projectInfoFromDB = await getProjectInfoFromDB(_key);

			// Set project manager address state variable
				console.log("Check bchain_account from DB: " + projectInfoFromDB.bchain_account);
				if (projectInfoFromDB.bchain_account) {
					console.log("Project manager bc_account found");
					setProjManagerAddressDB_state(projectInfoFromDB.bchain_account);
					// console.log("No project manager bc_account found");
					// setProjManagerAddressDB_state("------");
				}
			// Set txn hash state variable
				console.log("Check tx hash from DB: " + projectInfoFromDB.tx_hash);
				if (projectInfoFromDB.tx_hash) {
					console.log("Txn hash found");
					setProjectTxHash(projectInfoFromDB.tx_hash);

					// Next step
						console.log("Calling retrieveOnchainProjAndSubmissionData");
						retrieveOnchainProjAndSubmissionData(_key);
				} else {
					console.log("No txn hash found");
					alert("Project not found!");
					// Reload page to get rid of "&cfm=true" in URL
						window.location.replace("/browse");
				}

		} else if (_cfm == "true") { // If in confirmation mode, Keep checking for txn hash
			console.log("Project creation confirmation mode");
			setCfmMode(true);
			// Scroll to top
				// window.scrollTo({ top: 0, behavior: 'smooth' });
			// Activate loading icon
				controlLoadingIcon_2("loading");

			let counter = 0;
			let interval = setInterval(
				async function() {
					let projectInfoFromDB;
					try {
						projectInfoFromDB = await getProjectInfoFromDB(_key);
					} catch(err) {
						console.log("Error: ", err);
					}
					const checkTxn = projectInfoFromDB.tx_hash;
					console.log("checkTxn: " + checkTxn);
					if (checkTxn) {
						console.log("Txn hash found");
						// Set txn hash state variable
						setProjectTxHash(projectInfoFromDB.tx_hash);
						// Deactivate dioading icon
							controlLoadingIcon_2("default");
						clearInterval(interval);
						// Reload page to get rid of "&cfm=true" in URL
							let pageURL = window.location.href;
							pageURL = pageURL.split("&cfm=true").shift();
							window.location.replace(pageURL);
						// Next step
							// retrieveOnchainProjAndSubmissionData(_key);
					} else if (!checkTxn) {
						console.log("No txn hash found");
						counter++;
						console.log("Counter: " + counter);
						if (counter == 3) {
							clearInterval(interval);
							// Reload page to get rid of "&cfm=true" in URL
								let pageURL = window.location.href;
								pageURL = pageURL.split("&cfm=true").shift();
								window.location.replace(pageURL);
						}
					}
				},
			3000); // 3 sec interval
		}
	}

	async function getProjectManagerFromDB(_projectKey) { // NEW!
		console.log("getProjectManagerFromDB triggered");
		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'project', 
				project_key: _projectKey 
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				console.log("Check manager name from DB: ", returned_data.username);
				console.log("Check manager address from DB: ", returned_data.bchain_account);
				// Create a new object
				let managerData = {
					managerName: returned_data.username,
					managerAddress: returned_data.bchain_account
				};
				resolve(managerData);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}

	async function switchSigRequestMode(_mode) {
		console.log("switchSigRequestMode triggered with mode: " + _mode);

		const projectKey_ = getURLParameter('key');
		const returnedProjStatusInfo = await getProjectStatusAndPrivacy(projectKey_);
		console.log("Check Project Status & Privacy: ", returnedProjStatusInfo);

		const projectStatus = returnedProjStatusInfo.status; // 'waiting', 'open', 'closed'
		const projectPrivacy = returnedProjStatusInfo.privacy; // 'private', 'public'

		console.log("Check feedbackShown: " + feedbackShown); // testing
		console.log("Check projectWaiting: " + projectWaiting); // testing

		if (_mode == "on") {
			setMainBoxesVisible(false); // Need to do it this way for some reason, in addition to using 'main-boxes' class
			$(".main-boxes").hide();
			$(".signature-request-section").show();
		} else if (_mode == "off") {
			setMainBoxesVisible(true);
			$(".main-boxes").show();
			$(".signature-request-section").hide();
			if (projectStatus !== 'open') {
				$(".data-submission-section").hide();
			}
		}
	}

	async function getProjectInfoFromDB(_projectKey) {
		console.log("getProjectInfoFromDB triggered");
		console.log("Check userAuthInfo_global: ", userAuthInfo_global);

		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'project', 
				project_key: _projectKey 
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				console.log("check project info from DB: ", returned_data);

				if (returned_data) {
					let restriction_;

					// Set state variables
						setProjectInfo_offchain(returned_data);
						setProjTxnURL(BLOCK_EXPLORER_URL + returned_data.tx_hash);

					// Set project restriction type
						// Reset
							setSoloProject(false);
							setTeamProject(false);
							setOpenProject(false);

						console.log("returned_data.restriction.toLowerCase(): " + returned_data.restriction.toLowerCase());

						if ("solo" == returned_data.restriction.toLowerCase()) {
							setSoloProject(true);
							restriction_ = "solo";
						} else if ("open" != returned_data.restriction.toLowerCase() && "solo" != returned_data.restriction.toLowerCase()) {
							setTeamProject(true);
							restriction_ = returned_data.restriction.toLowerCase();
						} else if ("open" == returned_data.restriction.toLowerCase()) {
							setOpenProject(true);
							restriction_ = "open";
						}

					// If in private mode, set 'Privacy' texts & modes
					if (returned_data.private == 1) {

						console.log("Project is private");

						// Close all boxes, open 'signature request' box
							let authMessage, authSignature;
							if (userAuthInfo_global.message != null) {
								authMessage = userAuthInfo_global.message;
								authSignature = userAuthInfo_global.signature;
							}
							console.log("Check authMessage: " + authMessage);
							console.log("Check authSignature: " + authSignature);

							if (authMessage && authSignature) {
								switchSigRequestMode("off");
							} else {
								switchSigRequestMode("on");
							}

						// Set privacy status
							setPrivateStatus_state(true);

						// Set privacy text
							if ("solo" == returned_data.restriction.toLowerCase()) {
								setPrivacyText_state(privacyTextSoloON_state);
							} else if ("open" != returned_data.restriction.toLowerCase() && "solo" != returned_data.restriction.toLowerCase()) {
								setPrivacyText_state(privacyTextTeamON_state);
							} else if ("open" == returned_data.restriction.toLowerCase()) {
								setPrivacyText_state(privacyTextOpenON_state);
							}

					} else {

						// Open all boxes, close 'signature request' box
							switchSigRequestMode("off");
						// Set privacy status state var
							setPrivateStatus_state(false);
						// Set privacy text state var
							setPrivacyText_state(privacyTextOFF_state);
					}

					// Set privacy switch state var
						console.log("Check bc_account from DB: " + returned_data.bchain_account);
						const checkAddressComparison = compareMangerAndUserAddressesThenManageSettingSwitch(returned_data.bchain_account, restriction_, returned_data.private);
				}

				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}

	async function retrieveOnchainProjAndSubmissionData(_projectKey = null) {

		console.log("retrieveOnchainProjAndSubmissionData triggered");
		$(".bchain-button").hide();
		// $("#bchain-progress").show();

		let projKey;
		if (_projectKey) {
			projKey = _projectKey;
		} else {
			projKey = getURLParameter('key');
		}
		console.log("Check project key: " + projKey);
		console.log("Check userAuthInfo_global: ", userAuthInfo_global);
		// Retrieve data from blockchain

			// Check and set final manager name
				console.log("Calling onchain_retrieveProjectInfo");
				const projectInfoFromBchain = await onchain_retrieveProjectInfo(projKey);
				console.log("Check projectInfoFromBchain: ", projectInfoFromBchain);
				if (typeof projectInfoFromBchain !== 'undefined') {
					await checkAndProduceFinalManagerName(projKey, projectInfoFromBchain.managerName);
				}

			// Retrieve submission data from blockchain & insert into table
				console.log("Calling onchain_retrieveSubmissionsWithProjKey");
				const checkResult = await onchain_retrieveSubmissionsWithProjKey(projKey); // => prepareTable2Data() * * * *

			if (typeof projectInfoFromBchain !== 'undefined') {
				if (projectInfoFromBchain.timeStamp && checkResult == "success") {
					resetUserSubmissionInputSection(); // reset everyting in user sumbission input section
				}
			}

			// => prepareTable2Data() * * * *
	}

	async function getProjectStatusAndPrivacy(_projectKey) { // new!
		console.log("getProjectStatusAndPrivacy triggered with Project key: " + _projectKey);
		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'project_status', 
				project_key: _projectKey 
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				console.log("Check project status data from DB: ", returned_data);
				// Return data
				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}

	async function getProjectFeedbackFromDB(_projectKey) { // new!
		console.log("getProjectFeedbackFromDB triggered with Project key: " + _projectKey);
		return new Promise((resolve, reject) => {
			let postData = { type: 'project_feedback', project_key: _projectKey };
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				console.log("Check project data from DB: ", returned_data);
				// Return data
				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}

	async function getProjectFeedbackFromDB_AndSetStateVars(_projectKey) { 
		console.log("getProjectFeedbackFromDB_AndSetStateVars triggered with Project key: " + _projectKey);
		console.log("Check userAddress: " + userAddress);
		console.log("Check userAuthInfo_global: ", userAuthInfo_global);

		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'project_feedback', 
				project_key: _projectKey, 
				account: userAuthInfo_global.account, 
				message: userAuthInfo_global.message, 
				signature: userAuthInfo_global.signature 
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				console.log("Check project feedback data from DB: ", returned_data);

				// Set 'projectWaiting' here in addition to when checking onchain data just in case
					if (returned_data.project_state == "waiting") {
						console.log("Project waiting to open - 1");
						setProjectWaiting(true);
					} else {
						setProjectWaiting(false);
					}
				// Set feedback data ('projectClosed' also set here in addition to when checking onchain data just in case)
				if (returned_data.project_state == "closed") {
					console.log("Project closed");
					setProjectClosed(true);
					setProjectFeedback_offchain(returned_data); // state
						setFeedbackTitle(returned_data.title);
						// Added 7/7/25
							const originalTaskingText = returned_data.tasking_text;
							const formattedTaskingText = originalTaskingText.replace(/\n/g, '<br/>');
							setFeedbackTasking(DOMPurify.sanitize(formattedTaskingText));

						setFeedbackFilename(returned_data.file_name); // null if no file
						// For 'Update' section
							const origUpdateText = returned_data.update_text || "";
							const formattedUpdateText_  = origUpdateText.replace(/\n/g, '<br/>'); // replace new lines with <br/>
							let urlNotes_ = returned_data.url_notes || [];
							if (urlNotes_.length > 0) {
								urlNotes_ = JSON.parse(returned_data.url_notes || []);
							} else { urlNotes_ = []; }
							setUpdateText(DOMPurify.sanitize(formattedUpdateText_));
							setUrlNotesArray(urlNotes_);
							if (returned_data.proj_update == 1) {
								setShowUpdateBox(true);
							} else {
								setShowUpdateBox(false);
							}
				} else {
					setProjectClosed(false);
					setFeedbackTasking("------");
				}
				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}

	async function checkAndProduceFinalManagerName(_key, _managerName = null) { 

		// Get mananger name from DB & blockchain
			let managerName_Bchain = _managerName;

			const projectInfoFromDB = await getProjectInfoFromDB(_key);
			let managerName_DB = projectInfoFromDB.username;
			console.log("check manager name from DB: ", managerName_DB);

			// If no manager name from blockchain passed in, retrieve it here
			if (managerName_Bchain == null) {
				const projectInfoFromBchain = await onchain_retrieveProjectInfo(_key);
				managerName_Bchain = projectInfoFromBchain.managerName;
				console.log("check manager name from Bchain: ", managerName_Bchain);
			}

		let finalManagerName;
		if (managerName_Bchain !== managerName_DB) {
			finalManagerName = managerName_Bchain + " (now \"" + managerName_DB + "\")";
		} else {
			finalManagerName = managerName_Bchain;
		}
		setFinalManagerName(finalManagerName);
	}

	// Retrieve project info from blockchain
	async function onchain_retrieveProjectInfo(_projectKey, _counter=0) {
		console.log("- - - - - onchain_retrieveProjectInfo triggerd");
		console.log('_projectKey param: ' + _projectKey);

		// Make sure ioading icon is deactivated
			controlLoadingIcon_2("default");
		// Activate loading icon
			controlLoadingIcon_2("loading");

		// Prepare smart contract connection
		let contract_primary, contract_secondary;
		try {
			[contract_primary, contract_secondary] = await setupContract();
			setNotConnectedToBchain(false);
		} catch (err) {
			console.log("Error: ", err);
			console.log("Likely means failed to connect to blockchain");
			// $(".bchain-button").show();
			mainButtonSwitcher('connect'); // added 1/11/25 (1/22)
			$("#bchain-progress").hide();

			$(".data-submission-section").hide();
			setNotConnectedToBchain(true);
			// alert("Failed to connect to blockchain!");
			// Deactivate loading icon
				controlLoadingIcon_2("default");
			return;
		}

		let _contract;
		if (_counter == 0) {
			_contract = contract_primary;
			console.log("Provider: As initially set");
		} else {
			_contract = contract_secondary;
			console.log("Provider: Temporarily switched to secondary one (Alchemy)");
			// If in local environment, stick to contractPrimary
			if (process.env.NODE_ENV === "development") {
				console.log("Since in local environment, switching back to contractPrimary");
				_contract = contract_primary;
			}
		}

		let restriction_;

		try {
			const data = await _contract.retrieveProjectInfo(_projectKey);
			console.log('Project info retrieved (onchain): ', data);

			// If it's a TEAM project...
			if (restrictionOpenHash != data.restriction && restrictionSoloHash != data.restriction) { 
				console.log("This is a team project");
				setTeamProject(true);
				handleContinueClick("team"); // Hide 'Click when ready' button & show 'blockchain' connection button
				restriction_ = 'team';
			}

			// If it's a SOLO project...
			if (restrictionSoloHash == data.restriction) { 
				console.log("This is a solo project");
				setSoloProject(true);
				restriction_ = 'solo';
			}

			// If it's an OPEN project...
			if (restrictionOpenHash == data.restriction) { 
				console.log("This is an open project");
				setOpenProject(true);
				restriction_ = 'open';
			}

			// If no data is returned, keep trying
			if (!data.timeStamp || typeof data.timeStamp === "undefined") {
				console.log("Empty data");
				repeat_onchain_retrieveProjectInfo(_projectKey, _counter);

			} else { // If data found...
				setProjectInfo_onchain(data);
				setTeamURL(TEAMS_URL_BASE + "?teamkey=" + data.restriction);
				// seManagerURL(MANAGER_URL_BASE + "?key=" + data.managerAddress);

				// Check if project is closed
					let currentTime_fn = await getCurrentUNIXTime();
					let closeTime_fn = data.closeTime;

					console.log("* * * check project closed: " + closeTime_fn);
					console.log("* * * check current time: " + currentTime_fn);
					console.log("Check projectClosed: " + projectClosed);

					// Keep tasking text hidden if project is still open
					if (closeTime_fn > currentTime_fn) {
						console.log("Project still open");
						setFeedbackShown(false);
						setProjectClosed(false);
					} else {
						console.log("Project closed");
						setFeedbackShown(true);
						setProjectClosed(true);
					}

				// Check if project is waiting to open
					let openTime_fn = data.openTime;

					console.log("* * * check project close time: " + closeTime_fn);
					console.log("Check projectWaiting: " + projectWaiting);

					if (openTime_fn > currentTime_fn) {
						console.log("Project waiting to open - 2");
						setProjectWaiting(true);
					} else {
						setProjectWaiting(false);
					}

				// Make sure ioading icon is deactivated
					controlLoadingIcon_2("default");

				return data;
			}

		} catch (err) {
			console.log("Error: ", err);
			console.log("Likekly means specified project not found");
			if (_counter === 0 && process.env.NODE_ENV !== "development") {
				console.log("Project info read failed via wallet RPC; retrying via independent RPC");
				return onchain_retrieveProjectInfo(_projectKey, 1);
			}
			controlLoadingIcon_2("default");
		}
	}


	function repeat_onchain_retrieveProjectInfo(_projectKey, _counter) {
		if (_counter < 4) {
			delayed_repeat_onchain_retrieveProjectInfo(_projectKey, _counter);
		} else {
			console.log("/ / / / / Ending attempt to retrieve prediction data.")
			// Make sure ioading icon is deactivated
				controlLoadingIcon_2("default");
			$(".header-texts").hide();
			$(".retrieval-error-note").show();
		}
	}

	async function delayed_repeat_onchain_retrieveProjectInfo(_projectKey, _counter) {
		console.log("Keep trying to retrieve prediction data");
		console.log('/ / / / _counter: ' + _counter);
		let counter = _counter + 1;

		setTimeout(function() {
			onchain_retrieveProjectInfo(_projectKey, counter);
		}, 3000); // delay of 3 sec
	}

// End of project info retrieval section - - - - -


// Participant psi data submission sectiom - - - - -

	// Get team info from DB
	async function getTeamInfoFromDB(_teamKey) {
		console.log("getTeamInfoFromDB triggered");
		return new Promise((resolve, reject) => {
			let postData = { type: 'team_key', data: _teamKey };
			axios({
				url: TEAMS_API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				const returned_data = JSON.parse(res.data.data);
				if (returned_data !== "empty") {
					console.log("Check returned_data from DB: ", returned_data);
					resolve(returned_data);
				} else if (returned_data === "empty") { 
					console.log("No team data found!");
					resolve('empty'); 
				}
			})
			.catch((err) => { console.log("error response: " + err);
			});
		});
	}

	// Check user's team membership status
	async function checkTeamMembership(_teamKey = null) {
		console.log("checkTeamMembership() triggered");

		// Get user blockchain account
			const _bchain_account = await requestAccount();
			if (_bchain_account == "error") {
				console.log("_bchain_account request failed");
				return false;
			}
		// Get team key
			let teamKey;
			console.log("Check onchain team key: ", projectInfo_onchain.restriction);
			console.log("Check offchain team key: ", projectInfo_offchain.restriction);
			console.log("Check passed in team key: ", _teamKey);
			if (!_teamKey) {
				if (projectInfo_onchain.restriction) {
					teamKey = projectInfo_onchain.restriction; // onchain
				} else {
					teamKey = projectInfo_offchain.restriction; // offchain
				}
			} else {
				teamKey = _teamKey; // passed in
			}

		const teamInfo = await getTeamInfoFromDB(teamKey);
		if (teamInfo == 'empty') {
			console.log("No team data found!");
			return false;
		}
		const teamMembers = teamInfo.member_addr;
		console.log("Check team members: ", teamMembers);
		if (teamMembers.includes(_bchain_account)) {
			return true;
		} else {
			return false;
		}
	}
	
	// Prepare data for blockchain & server DB (triggered by save/submit button click)
	async function checkBeforeSaving() {

		console.log("checkBeforeSaving() triggered");

		// Check if project is closed
		if (projectClosed == true || projectWaiting == true) {
			$("#bchain-progress").hide(); // JIC
			mainButtonSwitcher('bchain'); // JIC
			alert("Project closed. Submission not accepted.");
			return; // stop txn
		}

		// Check if it's team project, if so, check if user is in the team
		if (teamProject_state == true) {
			const isTeamMember = await checkTeamMembership();
			if (isTeamMember == false) {
				$("#bchain-progress").hide(); // JIC
				mainButtonSwitcher('bchain'); // JIC
				alert("Your team membership could not be verified.");
				return; // stop txn
			} else {
				console.log("User is a team member");
			}
		}

		// Reset alert area
			console.log("Reset alerts ========================");
			// console.log('newUsername: ' + newUsername);
			// console.log('newUserEmail: ' + newUserEmail);
			// console.log('newUserPassword: ' + newUserPassword);
			// console.log('registerUser: ' + registerUser);
			// console.log("psiSubmissionText: " + psiSubmissionText);
			// console.log("FileHash: " + fileHash);
			// console.log("passwordCheckStatus: " + passwordCheckStatus);

			$(".input-alert-area").hide(300);
				$(".user-bchain-unrecognized").hide(300);
				$(".username-unavailable").hide(300);
				$(".user-email-unavailable").hide(300);
				$(".username-unavailable-check-pw").hide(300);
				$(".user-password-incorrect").hide(300);
				$(".onchain-user-pw-check-fail").hide(300);
			// Hide user info input section
				$(".user-info-input-section").hide(300);
			// Reset/hide latest submission row in table 2
				setShowLatestSubmission(false);

		// Check if any text field is empty
			let emptyTaskingText = false;
			let emptyFieldDetected = false;

			// Check tasking text
				if (psiSubmissionText) { 
					setErrorPsiSubmissionText(false);
				} else { 
					setErrorPsiSubmissionText(true);
					emptyTaskingText = true;
					emptyFieldDetected = true;
				}
			// Check new ONCHAIN user's new username & email (& optionally password
				if (registerUser === true && skipBlockchain === false) {
					if (newUsername) { 
						setErrorNewUsername(false);
					} else { 
						setErrorNewUsername(true);
						emptyFieldDetected = true;
					}
					if (newUserEmail) { 
						setErrorNewUserEmail(false);
					} else { 
						setErrorNewUserEmail(true);
						emptyFieldDetected = true;
					}
					if (passwordCheckStatus === "on") {
						if (newUserPassword) { 
							setErrorNewUserPassword(false);
						} else { 
							setErrorNewUserPassword(true);
							emptyFieldDetected = true;
						}
					}
				}
			// Check OFFCHAIN user's new username, password (& email for new)
				if (skipBlockchain === true) {
					if (newUsername) { 
						setErrorNewUsername(false);
					} else { 
						setErrorNewUsername(true);
						emptyFieldDetected = true;
					}
					if (newUserPassword) { 
						setErrorNewUserPassword(false);
					} else { 
						setErrorNewUserPassword(true);
						emptyFieldDetected = true;
					}
					if (registerUser === true) {
						if (newUserEmail) {	
							setErrorNewUserEmail(false);
						} else {
							setErrorNewUserEmail(true);
							emptyFieldDetected = true;
						}
					}
				}

			// If any empty field detected, stop process & alert user
				if (emptyTaskingText === true) {
					console.log("emptyTaskingText = true");
					if (skipBlockchain === true) {
						$(".user-info-input-section").show(300);
					}
					return; // Stop process
				}
				if (emptyFieldDetected === true) {
					console.log("emptyFieldDetected = true");
					$(".user-info-input-section").show(300);
					return; // Stop process
				}

			// If in (onchain user) check password mode, check password
				let passwordCheckResult = 'off';
				if (passwordCheckStatus === 'on') {
					passwordCheckResult = await checkUserPassword(newUsername, newUserPassword);
					console.log("passwordCheckResult: " + passwordCheckResult);
					// If password is invalid, stop txn, alert user & request again
					if (passwordCheckResult == "invalid") { 
						setPasswordCheckStatus("invalid");
					} else { // If password is valid
						setPasswordCheckStatus("valid");
					}
				}

		// If input fields are good, check new user info against user registry DB, and register if needed
			// For ON-chain user
			if (skipBlockchain === false) {
				console.log("CHECK POINT 1 - - - - " + passwordCheckResult);
				const registrationCheckResult = await checkAndRegisterNewUser_onchain(passwordCheckResult);
				if (registrationCheckResult == "stop") { 
					console.log("CHECK POINT 2 - - - -");
					mainButtonSwitcher('bchain'); // JIC
					$("#bchain-progress").hide(); // JIC
					return; // stop txn
				} 
			}
			// For OFF-chain user
			if (skipBlockchain === true) {
				const registrationCheckResult = await checkAndRegisterNewUser_offchain();
				if (registrationCheckResult == "stop") { return; } // stop txn
			}

		// With everything checked out...

			// ON-chain: Trigger & process blockchain transaction
				if (skipBlockchain === false) {
					prepareAndTriggerBlockchainTxn();
				}
			// OFF-chain: Save submission data to DB
				if (skipBlockchain === true) {
					storeSubmissionInDB_offchain();
				}
	}  
	// End of checkBeforeSaving()


	// Process transaction after checking user input fields & registration
	async function prepareAndTriggerBlockchainTxn() {

		// Hash user submission text (SHA-256)
		console.log("Hashing of submission started");
		const hashedSubmissionText = await hashData(psiSubmissionText);
		console.log("Hashing of submission complete");

		const projectKey_ = getURLParameter('key');

		// Prepare smart contract connection
			const provider_ = new ethers.providers.JsonRpcProvider(PROVIDER_URL)
			const contract_ = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider_);

		// Get existing submission count of this project from blockchain
			let submissionCount_before;
			try {
				submissionCount_before = await contract_.getSubmissionCount(projectKey_);
			} catch (err) {
				console.log("submissionCount retrieval error: ", err);
				alert("Could not connect to smart contract. Please try again.[1]");
				return;
			}
			console.log("Check submissionCount_before: " + submissionCount_before);

		// Call sendToBlockchain() function 
			console.log("Calling sendToBlockchain()");
			$("#bchain-progress").show();
			const returnedData = await sendToBlockchain(hashedSubmissionText);

		// Process returned data
			if (returnedData.transactionHash == "error") {
				console.log("Transaction failed");
				return;
			} else if (returnedData.transactionHash) { // if successful
				console.log("Transaction successful = = = = = = =");
				console.log("Check transactionHash: " + returnedData.transactionHash);
				// $(".bchain-button").show();
				// $("#bchain-progress").hide();
				// resetUserSubmissionInputSection(); // reset everyting in user sumbission input section

				checkReturnedBchainDataAndStoreOnDatabase(hashedSubmissionText, submissionCount_before, returnedData, 0, 0) 
			}
	}

	async function checkReturnedBchainDataAndStoreOnDatabase(_hashedSubmissionText, _submissionCount_before, _returnedData, _counter=0, _counter2=0) {

		console.log("checkReturnedBchainDataAndStoreOnDatabase triggered");	
		let counter = _counter;
		let counter2 = _counter2;

		if (counter < 5 && counter2 < 3) {
			console.log("Submission not found onchain yet - keep trying");
		} else {
			console.log("Submission count not updated after numerous attempts - stop process");
			alert("Could not confirm submission on blockchain. Please try again.");
			mainButtonSwitcher('bchain'); 
			$("#bchain-progress").hide();
			counter = counter2 = 0; // reset JIC
			return;
		}

		const transactionHash_bc = _returnedData.transactionHash;
		const bchain_account_bc = _returnedData.bchain_account;
		const usernameDB_bc = _returnedData.usernameDB;
		const projectKey_bc = _returnedData.projectKey;

		let submissionCount_after, submissionArray_after, userPsiDataHash_after;
		let submissionIndex_;

		// Prepare smart contract connection
			const provider_ = new ethers.providers.JsonRpcProvider(PROVIDER_URL)
			const contract_ = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider_);

		// Get current/new count of this project from blockchain
			try {
				submissionCount_after = await contract_.getSubmissionCount(projectKey_bc);
			} catch (err) {
				console.log("submissionCount retrieval error: ", err);
				alert("Could not connect to smart contract.[2]");
				mainButtonSwitcher('bchain'); 
				$("#bchain-progress").hide();
				counter = counter2 = 0; // reset JIC
				return;
			}
			console.log("Check submissionCount_after: " + submissionCount_after);

		// Check if submission count has been updated
			// If not, keep trying
			if (_submissionCount_before >= submissionCount_after) {
				counter++;
				setTimeout(function() {
					checkReturnedBchainDataAndStoreOnDatabase(_hashedSubmissionText, _submissionCount_before, _returnedData, counter, counter2);
				}, 3000); // delay of 3 sec

		// If submission count has been updated, get user submission data & confirm it's the right one, then store it in DB
			} else if (_submissionCount_before < submissionCount_after) {

				console.log("Submission count updated - check user submission data");
				counter = 0; counter2++;
				let fromIndex = parseInt(_submissionCount_before); // not subtracting 1
				let toIndex = parseInt(submissionCount_after -1);

				// Retrieve user submission data from blockchain
					try {
						submissionArray_after = await contract_.retrieveSubmissionsWithProjKey(projectKey_bc, fromIndex, toIndex, false);
					} catch (err) {
						console.log("retrieveSubmissionsWithProjKey error: ", err);
						alert("Could not retrieve & confirm submission on blockchain. Please submit your data again.");
						mainButtonSwitcher('bchain'); 
						$("#bchain-progress").hide();
						counter = counter2 = 0; // reset JIC
						return;
					}
					console.log("Check submissionArray_after: ", submissionArray_after);

				// Compare retrieved data wtih one stored beforehand
					let countDiff = submissionCount_after - _submissionCount_before;
					let matchFound = false;
					console.log("Check countDiff: " + countDiff);

					for (let i = 0; i < countDiff; i++) {
						console.log("Check userPsiData: " + submissionArray_after[i].userPsiData);
						if (submissionArray_after[i].userPsiData == _hashedSubmissionText) {
							console.log("Match found");
							submissionIndex_ = fromIndex + i;
							matchFound = true;
						}
					};
					if (matchFound == false) {
						checkReturnedBchainDataAndStoreOnDatabase(_hashedSubmissionText, _submissionCount_before, _returnedData, counter, counter2);
					}
					if (matchFound == true) {
						storeSubmissionInDB();
					}
			}

		async function storeSubmissionInDB() {
			console.log("storeInDB() triggered");
			// Insert submission data into DB
			const insertionResult = await storeSubmissionInDB_onchain(bchain_account_bc, projectKey_bc, submissionIndex_, usernameDB_bc, _hashedSubmissionText, transactionHash_bc);
			// Trigger next steps (retrieval of project & submission data, scroll to submission table)
			console.log("Calling retrieveOnchainProjAndSubmissionData");
			await retrieveOnchainProjAndSubmissionData();
			userSubmissionsTable.current.scrollIntoView({ behavior: 'smooth' });
		}

	}
		

	// Check new ON-chain user info against user registry DB, register if needed
	async function checkAndRegisterNewUser_onchain(_passwordCheckStatus = 'off') {

		// Get onchain user's blockchain address
			const bchain_account = await requestAccount()
			if (bchain_account == "error") {
				console.log("bc_account request failed");
				alert("Can't access your blockchain address. Please try again.");
				return "stop"; // prevent txn
			} else {
				setUserAddress(bchain_account); // set state variable
			}
		// Check onchain user registration status with blockchain address 
			const userInfoArrayFromDB = await getUserInfoFromDB(bchain_account, 'blockchain');
			console.log("Check userInfoArrayFromDB: ", userInfoArrayFromDB);

			// If onchain user is not in register mode & is not found in DB, request registration
				if (userInfoArrayFromDB === 'none' && registerUser === false) {
					console.log("User not found in DB - request registration");
					$(".user-info-input-section").show(300);
					$(".user-bchain-unrecognized").show(300);
					setRegisterUser(true); // set state variable
					// window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
					return "stop"; // prevent txn
			// If found...
				} else if (registerUser === false) { 
					console.log("User found in DB - continue txn");
				}

		// Check availability of NEW username & email address in DB
			if (registerUser === true) { 

				console.log("Check availability of NEW username & email address in DB");
				const arrayFromNameDB = await getUserInfoFromDB(newUsername, 'username'); // This 'username" variable from input box
				const arrayFromEmailDB = await getUserInfoFromDB(newUserEmail, 'email');
				const arrayFromNameDB_offchain = await getUserInfoFromDB_offchain(newUsername, 'username'); 

				$(".input-alert-area").hide(); //reset
				// $(".user-bchain-unrecognized").hide(); //reset
				// $(".username-unavailable").hide(); //reset
				// $(".userEmail-unavailable").hide(); // reset

				let nameTaken = false; let emailTaken = false; let passwordInvalid = false;

				if (arrayFromNameDB !== 'none') { // If name already taken
					$(".username-unavailable").show(300);
					$(".user-info-input-section").show(300);
					setErrorNewUsername(true);
					nameTaken = true;
				}
				if (arrayFromEmailDB !== 'none') { // If email already taken
					$(".user-email-unavailable").show(300);
					$(".user-info-input-section").show(300);
					setErrorNewUserEmail(true);
					emailTaken = true;
				}

				if (arrayFromNameDB_offchain !== 'none') { // If name found on OFF-chain side of user-registry DB...
					console.log("Username found on OFF-chain DB; _passwordCheckStatus: " + _passwordCheckStatus);

					if (_passwordCheckStatus !== 'valid' && _passwordCheckStatus !== 'invalid') { // If password not yet checked, ask for password
						console.log("Username already exists in OFF-chain DB - ask for password");
						$(".user-info-input-section").show(300);
						$(".username-unavailable-check-pw").show(300);
						$(".password-field").show(300);
						setErrorNewUsername(true);
						setErrorNewUserPassword(true);
						setPasswordCheckStatus("on");
						nameTaken = true;

					} else if (_passwordCheckStatus === 'invalid') { // if password provided has proved invalid, reset input fields & alert user
						console.log("Password check failed - alert user & stop process * * * * *");
						$(".user-info-input-section").show(300);
						$(".onchain-user-pw-check-fail").show(300);
						$(".password-field").hide(300);
						setErrorNewUsername(true);
						setErrorNewUserPassword(false); // reset
						// Clear all text input fields
							setNewUsername('');
							setNewUserPassword('');
							setNewUserEmail('');
						passwordInvalid = true;
					} else if (_passwordCheckStatus === 'valid') { // If password provided has been verified, reset password check status & continue
						console.log("Password check successful - reset setPasswordCheckStatus to 'off'");
						setPasswordCheckStatus("off"); // Reset
					}
				}

				if (nameTaken == true || emailTaken == true || passwordInvalid == true) { // Stop if any taken
					// window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
					return "stop"; // prevent txn
				}
			}

		// If all good, insert user into into DB
			if (registerUser === true) { 
				const versionNum = 1;
				let DBUpdateResult = await storeUserInfoInDB_onchain('original', newUsername, bchain_account, newUserEmail, versionNum); 
				console.log("DBUpdateResult: ", DBUpdateResult);
				if (DBUpdateResult === 'success') {
					setRegisterUser(false); // reset
					$(".input-alert-area").hide(300);
				}
			}

		return "success";

	} // End checkAndRegisterNewUser_onchain()


	// Check new OFF-chain user info against user registry DB, register if needed
	async function checkAndRegisterNewUser_offchain() {

		// If in LOGIN mode...

		if (registerUser === false) { 

			// If username is not found in DB, request registration
			const arrayFromNameDB_offchain = await getUserInfoFromDB_offchain(newUsername, 'username');
			console.log("Check arrayFromNameDB_offchain: ", arrayFromNameDB_offchain);

				if (arrayFromNameDB_offchain === 'none') {
					console.log("User not found in DB - request registration");
					$(".user-info-input-section").show(300);
					$(".user-name-unrecognized").show(300);
					setErrorNewUsername(true);
					// setRegisterUser(true); 
					return "stop"; // prevent txn
				}

			// Check user password against offchain DB, if in corrrect alert user
			const passwordCheckResult = await checkUserPassword(newUsername, newUserPassword);

				if (passwordCheckResult === 'invalid') {
					$(".user-info-input-section").show(300);
					$(".user-password-incorrect").show(300);
					setErrorNewUserPassword(true);
					return "stop"; // prevent txn
				}
		}

		// If in REGISTRATION mode...

		if (registerUser === true) { 
			// (Check availability of NEW username in both OFF-chain & ON-chain user-registry DB)

			// Off-chain
				const arrayFromNameDB_offchain = await getUserInfoFromDB_offchain(newUsername, 'username');
			// On-chain
				const arrayFromNameDB_onchain = await getUserInfoFromDB(newUsername, 'username');
				console.log("Check arrayFromNameDB_onchain: ", arrayFromNameDB_onchain);

			$(".input-alert-area").hide(); //reset

			// If name found on OFF-chain side of user-registry DB, alert user
				if (arrayFromNameDB_offchain !== 'none') { 
					console.log("Username already exists in OFF-chain DB - alert user & stop process");
					$(".user-info-input-section").show(300);
					$(".username-unavailable").show(300);
					// $("#password-field").show(300);
					setErrorNewUsername(true);
					// setErrorNewUserPassword(true);
					return "stop"; // prevent txn
				}

			// If name already taken on ON-chain side of user registry, check user's wallet address by comparing it to the one in DB
				if (arrayFromNameDB_onchain !== 'none') { 

					console.log("Username already exists in ON-chain DB - compare wallet addresses");
					// Retrieve wallet address from onchain DB based on new username
						const usernameBchainAddress = await arrayFromNameDB_onchain['bchain_address'];
					// Get current user's address from wallet
						const bchain_account = await requestAccount();
						// If unable to connect to user's wallet and/or get address, ask user to connect wallet and retry
						if (bchain_account == "error") {
							console.log("bc_account request failed");
							$(".user-info-input-section").show(300);
							$(".username-unavailable-check-bchain").show(300);
							setErrorNewUsername(true);
							return "stop"; // prevent txn
						} else {
							setUserAddress(bchain_account); // unnecessary?
						}

					if (usernameBchainAddress !== bchain_account) { // If the addresses do not match, alert user the username is unavailable)
						console.log("Addresses don't match - alert user & stop process * * * * *");
						$(".user-info-input-section").show(300);
						$(".username-unavailable-check-bchain-fail").show(300);
						setErrorNewUsername(true);
						setKeepUserInputFieldsVisible(true);
						return "stop"; // prevent txn
					}

				} 
		}

		// If all good, insert user into into DB
			if (registerUser === true) { 
				const versionNum = 1;
				let DBUpdateResult = await storeUserInfoInDB_offchain('original', newUsername, newUserEmail, newUserPassword, versionNum); 
				console.log("DBUpdateResult: ", DBUpdateResult);
				if (DBUpdateResult === 'success') {
					setRegisterUser(false); // reset
					$(".input-alert-area").hide(300);
				}
			}

		return "success";

	} // End checkAndRegisterNewUser_offchain()

// End of participant psi data submission section - - - - -


// Check user password against offchain DB

	async function checkUserPassword(_username, _password) {

		console.log("checkUserPassword triggered - - -");
		console.log("Check _password: " + _password);
		return new Promise((resolve, reject) => {
			let postData = {
				type: 'password_check',
				username: _username,
				password: _password
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry-offchain.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = res.data; // 'valid' or 'invalid'
				console.log("checkUserPassword returned_data (user-registry-offchain): ", returned_data);
				resolve(returned_data);
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}


// Insert user info to User Registry DB (ON-chain) - - - - -

	async function storeUserInfoInDB_onchain(_update_type, _username, _bchain_address, _email, _version_num = 1) {
		console.log("function storeUserInfoInDB_onchain triggered");
		console.log("Check _update_type: " + _update_type);
		console.log("Check _username: " + _username);
		console.log("Check _bchain_address: " + _bchain_address);
		console.log("Check _email: " + _email);
		console.log("Check _version_num: " + Number(_version_num));

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'insert', // 'insert' or 'query'
				update_type: _update_type, // 'original' or 'update'
				username: _username,
				bchain_address: _bchain_address, 
				email: _email,
				version_num: _version_num
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
				.then((res) => { 
					const returned_data = JSON.parse(res.data);
					console.log("Check returned_data: ", returned_data);
					if (returned_data !== 'error') {
						resolve(returned_data);
					} else { 
						console.log("Could not insert data to DB!");
						resolve(null); 
					}
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
		});
	}

// Insert user info to User Registry DB (OFF-chain) - - - - -

	async function storeUserInfoInDB_offchain(_update_type, _username, _email, _password, _version_num = 1) {
		console.log("function storeUserInfoInDB_offchain triggered");
		console.log("Check _update_type: " + _update_type);
		console.log("Check _username: " + _username);
		console.log("Check _email: " + _email);
		console.log("Check _version_num: " + Number(_version_num));

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'insert', // 'insert' or 'query'
				update_type: _update_type, // 'original' or 'update'
				username: _username,
				email: _email,
				password: _password,
				version_num: _version_num
			};
			axios({ 
				url: USER_API_ENDPOINT_ROOT + "user-registry-offchain.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
				.then((res) => { 
					const returned_data = JSON.parse(res.data);
					// const returned_data = res.data;
					console.log("Check returned_data: ", returned_data);
					if (returned_data !== 'error') {
						resolve(returned_data);
					} else { 
						console.log("Could not insert data to DB!");
						resolve(null); 
					}
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
		});
	}


// Blockhain transaction for user psi submission - - - - -
	
	async function sendToBlockchain(_hashedSubmissionText) {

		console.log("- - - - - sendToBlockchain() triggered");
		$(".bchain-button").hide();
		$("#bchain-progress").show();
		
		if (projectClosed == true || projectWaiting == true) {
			$("#bchain-progress").hide();
			mainButtonSwitcher('bchain');
			alert("Project closed. Submission not accepted.");
			return; // stop txn
		}

		// Obtain user blockchain account
			const bchain_account = await requestAccount();
			if (bchain_account == "error") {
				console.log("bc_account request failed");
			}
		// Retrieve user info from DB
			const userInfoArrayFromDB = await getUserInfoFromDB(bchain_account, 'blockchain');
			const usernameDB = userInfoArrayFromDB['username'];
		// Get project key from URL
			const projectKey = getURLParameter('key');

		console.log("Check bc account: " + bchain_account);
		console.log("Check _hashedSubmissionText: " + _hashedSubmissionText);
		console.log("Check _username: " + usernameDB);
		console.log("Check _projectKey: " + projectKey);
		console.log("Check fileHash: " + fileHash);

		// Prepare smart contract connection
			const provider = new ethers.providers.Web3Provider(window.ethereum)
			const signer = provider.getSigner();
			const contract = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, signer);

		let transaction, transactionHash;

		// Set up LISTENER for submissionCreated event
			// async function onSubmissionCreated(_submissionIndex, _userAddress, _userName, _userPsiData, _userFileHash) {
			// 	console.log("* * * * * Emitted contract event detected");
			// 	console.log("Submission Index:", _submissionIndex);
			// 	console.log("User address:", _userAddress);
			// 	console.log("User name:", _userName);
			// 	console.log("User Psi data:", _userPsiData);
			// 	console.log("User file hash:", _userFileHash);
			// 	console.log("transactionHash: " + transactionHash);

			// 	// Make sure submissionIndex is a number
			// 		let submissionIndex;
			// 		if (typeof _submissionIndex === 'number') {
			// 			submissionIndex = _submissionIndex;
			// 		} else { submissionIndex = _submissionIndex.toNumber(); }

			// 	if (_userAddress.toLowerCase() === bchain_account.toLowerCase()) {

			// 		contract.removeListener("submissionCreated", onSubmissionCreated);

			// 		// Insert submission data to DB
			// 			console.log("Triggering storeSubmissionInDB_onchain - - - -");
			// 			const insertionResult = await storeSubmissionInDB_onchain(bchain_account, projectKey, submissionIndex, usernameDB, _hashedSubmissionText, transactionHash);
						
			// 		// Trigger next steps (retrieval of project & submission data, scroll to submission table)
			// 			console.log("Calling retrieveOnchainProjAndSubmissionData");
			// 			retrieveOnchainProjAndSubmissionData();
			// 			userSubmissionsTable.current.scrollIntoView({ behavior: 'smooth' });
			// 	}
			// 	// $(".bchain-button").show();
			// 	// $("#bchain-progress").hide();
			// };
			// provider.once("block", () => {
			// 	contract.once("submissionCreated", onSubmissionCreated);
			// });

		try {
			console.log("========== Calling contract.submitPsiData()");
			transaction = await contract.submitPsiData(projectKey, usernameDB, _hashedSubmissionText, fileHash);
			// Wait for mining through the app's independent RPC endpoint,
			// not MetaMask's injected provider, which may report receipts late.
			const receiptProvider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
			const receipt = await receiptProvider.waitForTransaction(transaction.hash, 1, 120000);
			if (!receipt || receipt.status !== 1) {
				throw new Error("Transaction was not confirmed successfully by the RPC provider.");
			}

			console.log("Txn success");
			console.log("txHash: " + receipt.transactionHash);
			transactionHash = receipt.transactionHash;
		} catch (err) {
			console.log("Error: ", err);
			transactionHash = "error";
			// Remove listener
				// console.log("Removing listener for submissionCreated");
				// contract.removeListener("submissionCreated", onSubmissionCreated);
			alert("Transaction failed.");
			mainButtonSwitcher('bchain'); 
			$("#bchain-progress").hide();
		}

		// $(".bchain-button").show();
		// $("#bchain-progress").hide();

		return { transactionHash: transactionHash, usernameDB: usernameDB, bchain_account: bchain_account, projectKey: projectKey };

	} // End of sendToBlockchain()
	

	async function insertTxHashInDB(_projectKey, _bchain_account, _txHash) {
		
		setTimeout(function() {		

			console.log("function insertTxHashInDB triggered");
			console.log("Check _projectKey: " + _projectKey);
			console.log("Check _bchain_account: " + _bchain_account);
			console.log("Check _txHash: " + _txHash);

			return new Promise((resolve, reject) => {
				let postData = {
					type: 'tx_hash',
					project_key: _projectKey, 
					bchain_account: _bchain_account,
					tx_hash: _txHash
				};
				axios({ 
					url: API_ENDPOINT_ROOT + "store-data-db.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					// const returned_data = JSON.parse(res.data);
					const returned_data = res.data.result;
					console.log("Check returned_data: ", returned_data);
					if (returned_data !== 'error') {
						resolve(returned_data);
					} else { 
						console.log("Could not insert data to DB!");
						resolve(null); 
					}
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
			});
		}, 1500); // delay of 1.5 sec (waiting for submission row to be created in DB)
	}


// Store submission data to DB (ON-chain version) - - - -

	async function storeSubmissionInDB_onchain(_bchain_account, _projectKey, _submissionIndex, _usernameDB, _hashedSubmissionText, _txHash_fn) {

		if (projectClosed == true || projectWaiting == true) {
			$("#bchain-progress").hide();
			mainButtonSwitcher('bchain'); 
			alert("Project closed. Submission not accepted.");
			return; // stop txn
		}
		console.log("function storeSubmissionInDB_onchain triggered");
		console.log("Check _bchain_account: " + _bchain_account);
		console.log("Check _projectKey: " + _projectKey);
		console.log("Check _submissionIndex: " + _submissionIndex);
		console.log("Check _usernameDB: " + _usernameDB);
		console.log("Check _hashedSubmissionText: " + _hashedSubmissionText);
		console.log("Check fileNameFinal: " + fileNameFinal);
		console.log("Check fileHash: " + fileHash);
		console.log("Check _txHash_fn: " + _txHash_fn);
		// Get current time
			const currentTime = new Date().toISOString().slice(0, 19).replace('T', ' ');

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'submission',
				project_key: _projectKey,
				index_num: _submissionIndex,
				bchain_account: _bchain_account,
				username: _usernameDB,
				submission_time: currentTime,
				original_submission: psiSubmissionText,
				hashed_submission: _hashedSubmissionText,
				file_name: fileNameFinal,
				file_hash: fileHash,
				tx_hash: _txHash_fn
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "store-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				// const returned_data = JSON.parse(res.data);
				const returned_data = res.data.result;
				console.log("Check returned_data: ", returned_data);
				if (returned_data !== 'error') {
					setShowLatestSubmission(true);
					resolve(returned_data);
				} else { 
					console.log("Could not insert data to DB!");
					resolve(null); 
				}
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}


// Store user submission data to DB (OFF-chain version)

	async function storeSubmissionInDB_offchain() {
		
		if (projectClosed == true || projectWaiting == true) {
			$("#bchain-progress").hide();
			mainButtonSwitcher('bchain'); 
			alert("Project closed. Submission not accepted.");
			return;
		}
		// Get project key from URL
			const projectKey = getURLParameter('key');
		// Get submission count
			const submissionCounts = await getProjectSubmissionCountFromDB(projectKey);
			const submissionCount_offchain = submissionCounts['off_chain_count'];
			console.log("Check submissionCount (offchain): " + submissionCount_offchain);
			let submissionIndex = submissionCount_offchain;
			console.log("Check submissionIndex (offchain): " + submissionIndex);
		// Hash user submission text (SHA-256)
			console.log("hashedSubmissionText()");
			const hashedSubmissionText = await hashData(psiSubmissionText);

		console.log("function storeSubmissionInDB_offchain triggered");
		console.log("Check projectKey: " + projectKey);
		console.log("Check index_num: " + submissionIndex); // testing 7/31/24
		console.log("Check newUsername: " + newUsername);
		console.log("Check hashedSubmissionText: " + hashedSubmissionText);
		console.log("Check fileNameFinal: " + fileNameFinal);
		console.log("Check fileHash: " + fileHash);
		// Get current time
			const currentTime = new Date().toISOString().slice(0, 19).replace('T', ' ');

		return new Promise((resolve, reject) => {
			let postData = {
				type: 'submission_offchain',
				project_key: projectKey,
				index_num: submissionIndex, // testing 7/31/24
				username: newUsername,
				submission_time: currentTime,
				original_submission: psiSubmissionText,
				hashed_submission: hashedSubmissionText,
				file_name: fileNameFinal,
				file_hash: fileHash
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "store-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				// const returned_data = JSON.parse(res.data);
				const returned_data = res.data.result;
				console.log("Check returned_data: ", returned_data);
				if (returned_data !== 'error') {
					resolve(returned_data);
					console.log("Success! Check returned_data: ", returned_data);
					setShowLatestSubmission(true);
					// Reset project & submissions data (to update tables)
						resetUserSubmissionInputSection(); // reset everyting in user sumbission input section
						// setupBlockchain(); // reboot blockchain connection (project & submission data retrieval again

						console.log("Calling retrieveOnchainProjAndSubmissionData");
						retrieveOnchainProjAndSubmissionData();

						userSubmissionsTable.current.scrollIntoView({ behavior: 'smooth' });
				} else { 
					console.log("Could not insert data to DB!");
					resolve(null); 
				}
			}) 
			.catch((err) => { 
				console.log("error response: ", err);
			});
		});
	}


// Participant submissions RETRIEVAL section - - - - -

	async function onchain_retrieveSubmissionsWithProjKey(_projectKey, _fromIndex=0, _toIndex=0, _all=true, _counter=0) {
		console.log("- - - - - onchain_retrieveSubmissionsWithProjKey triggerd");
		console.log('_projectKey: ' + _projectKey);
		console.log('_fromIndex: ' + _fromIndex);
		console.log('_toIndex: ' + _toIndex);
		console.log('_all: ' + _all);

		console.log("onLoad_global: " + onLoad_global);

		// controlLoadingIcon_2("loading");
		$(".bchain-button").hide();
		$("#bchain-progress").show();
		
		// Prepare smart contract connection
			let contract_primary, contract_secondary;
			try {
				[contract_primary, contract_secondary] = await setupContract();
			} catch (err) {
				console.log("Error: ", err);
				console.log("Likely means failed to connect to blockchain");
				setNotConnectedToBchain(true);
				// Deactivate ioading icon
					// controlLoadingIcon_2("default");
				mainButtonSwitcher('bchain'); 
				$("#bchain-progress").hide();
				return "error";
			}

		let _contract;
		if (_counter <= 1) {
			_contract = contract_primary;
			console.log("Provider: As initially set (primary)");
		} else {
			_contract = contract_secondary;
			console.log("Provider: Temporarily switched to Alchemy: ", contract_secondary);
			// If in local environment, stick to contractPrimary
				if (process.env.NODE_ENV === "development") {
					console.log("Since in local environment, switching back to contractPrimary");
					_contract = contract_primary;
				}
		}

		// Deactivate loading icon & show appropriate button
			function manageIconAndButton() { // added 1/24/25 * * *
				// controlLoadingIcon_2("default");
				if (onLoad_global == true) { 
					mainButtonSwitcher('connect');
				} else {
					mainButtonSwitcher('bchain');
				}
				onLoad_global = false; // reset
				$("#bchain-progress").hide();
			}

		try {
			let data = await _contract.retrieveSubmissionsWithProjKey(_projectKey, _fromIndex, _toIndex, _all);
			console.log('Check user submission data retrieved from blockchain: ', data);
			// CHECK
				console.log("data[0].userTimeStamp: " + data[0].userTimeStamp);
			// Activate loading icon
				// controlLoadingIcon_2("loading");

			// If no data returned...
			if (!data[0].userTimeStamp || data[0].userTimeStamp == 0 || typeof data[0].userTimeStamp === "undefined") {

				console.log("Empty data");
				data = 'empty';
				manageIconAndButton();
				// Set the following to add "-----" to the table before repeating the retrival process
					// setSubmissionArray(data);
					await prepareTable2Data(data); 
				// Check DB for submission data, if any found, repeat the process
					const submissionCount= await getProjectSubmissionCountFromDB(_projectKey);
					console.log("Check submissionCount: ", submissionCount);
					if (submissionCount.on_chain_count > 0) {
						$(".bchain-button").hide();
						$("#bchain-progress").show();
						repeat_onchain_retrieveSubmissionsWithProjKey_Step1(_projectKey, _fromIndex, _toIndex, _all, _counter);
					}
			// If data returned, process it
			} else {
				console.log("Data found");
				manageIconAndButton();

				setSubmissionArray(data);
				prepareTable2Data(data); // => Check & retrieve both on-chain & off-chain submissions in DB
				
				return "success";
			}
		} catch (err) {
			if (_counter === 0 && process.env.NODE_ENV !== "development") {
				console.log("Submission read failed via wallet RPC; retrying via independent RPC");
				return onchain_retrieveSubmissionsWithProjKey(_projectKey, _fromIndex, _toIndex, _all, 2);
			}
			manageIconAndButton();
			console.log("Error: ", err);
			console.log("Likekly means no submissions found");

			return "error";
		}
	}

	function repeat_onchain_retrieveSubmissionsWithProjKey_Step1(_projectKey, _fromIndex, _toIndex, _all, _counter) {
		console.log("Keep trying to retrieve submission data");
		if (_counter < 4) {
			repeat_onchain_retrieveSubmissionsWithProjKey_Step2(_projectKey, _fromIndex, _toIndex, _all, _counter);
		} else {
			console.log("/ / / / / Ending attempt to retrieve prediction data.")
				// Make sure ioading icon is deactivated
					// controlLoadingIcon_2("default"); // JIC
				mainButtonSwitcher('bchain'); 
				$("#bchain-progress").hide();
				// $(".header-texts").hide();
				// $(".retrieval-error-note").show();
		}
	}

	async function repeat_onchain_retrieveSubmissionsWithProjKey_Step2(_projectKey, _fromIndex, _toIndex, _all, _counter) {
		console.log("Keep trying to retrieve submission data");
		console.log('/ / / / _counter: ' + _counter);
		let counter = _counter + 1;

		setTimeout(function() {
			onchain_retrieveSubmissionsWithProjKey(_projectKey, _fromIndex, _toIndex, _all, counter);
		}, 3000); // delay of 3 sec
	}

// End of participant submissions RETRIEVAL section - - - - -


	async function getSubmissionsArray_onchain_DB(_projectKey) {
		console.log("getSubmissionsArray_onchain_DB triggered");
		console.log("Check _projectKey: " + _projectKey);
		console.log("Check userAddress: " + userAddress);
		console.log("Check userAuthInfo_global: ", userAuthInfo_global);

		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'submissions_array',
				project_key: _projectKey,
				account: userAuthInfo_global.account, 
				message: userAuthInfo_global.message, 
				signature: userAuthInfo_global.signature
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Submissions array: ", returned_data);
				if (returned_data !== 'empty') {
					resolve(returned_data);
				} else {
					resolve(null);
				}
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}	

	async function getSubmissionsArray_offchain_DB(_projectKey) {
		console.log("getSubmissionsArray_offchain_DB triggered");
		console.log("Check _projectKey: " + _projectKey);
		// console.log("Check userAddress: " + userAddress);

		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'offchain_submissions_array',
				project_key: _projectKey
				// account: userAuthInfo_global.account, 
				// message: userAuthInfo_global.message, 
				// signature: userAuthInfo_global.signature
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Offchain submissions array: ", returned_data);
				if (returned_data !== 'empty') {
					resolve(returned_data);
				} else {
					resolve(null);
				}
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}	


	async function getSpecificSubmissionData(_projectKey, _indexNum, _dataIsOnchain) {
		console.log("Check _dataIsOnchain: " + _dataIsOnchain);
		console.log("Check userAuthInfo_global: ", userAuthInfo_global);

		return new Promise((resolve, reject) => {
			let postData = { 
				type: 'specified_submission',
				project_key: _projectKey,
				index_num: _indexNum,
				dataIsOnchain: _dataIsOnchain,
				account: userAuthInfo_global.account, 
				message: userAuthInfo_global.message, 
				signature: userAuthInfo_global.signature 
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = JSON.parse(res.data.data);
				console.log("Submission data: ", returned_data);
				if (returned_data.project_key) {
					resolve(returned_data);
				} else {
					resolve(null);
				}
				// validateFileHash(_fileAddr, _predictionArray);
				// setFileAddr(_fileAddr);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}	

	async function openFileLink(_indexNum, _dataIsOnchain) {
		console.log("openFileLink triggered");
		console.log("Check _indexNum: " + _indexNum);

		// Open an empty tab first
			const newTab = window.open(); 
			if (!newTab) {
				alert("Popup blocked! Please allow popups for this site.");
				return;
			}

		let projectKey = getURLParameter('key');

		try {
			const submissionData = await getSpecificSubmissionData(projectKey, _indexNum, _dataIsOnchain);

			const fileURL = UPLOADS_FOLDER_URL + submissionData.file_name;
			newTab.location.href = fileURL; // Assign the final URL

		} catch (error) {
			console.error("Failed to open file:", error);
			newTab.close(); // Close the tab if something goes wrong
			alert("File not found");
		}
	}

	function handleSkipBlockchainSwitch() { // on-chain or off-chain
		console.log('handleSkipBlockchainSwitch triggered');
		setSkipBlockchain(!skipBlockchain);
		resetSubmissionPreferenceArea();
	}

	async function resetSubmissionPreferenceArea() {
		console.log('resetSubmissionPreferenceArea triggered');
		$(".continue-button").show(200);
		$(".chain-explanation").show(200);
		$(".user-info-input-section").hide(200);
		$(".input-alert-area").hide(200);
		$(".new-or-returning").hide(200);
		$(".bchain-button-section").hide(200);
		$(".offchain-submit-button").hide(200);
		$(".team-project-notice").hide(200);
		setRegisterUser(false);
		setNewUsername('');
		setNewUserPassword('');
		setNewUserEmail('');
		setErrorNewUsername(false);
		setErrorNewUserPassword(false);
		setErrorNewUserEmail(false);
	}

	async function handleLinksClick(_mode) {
		if (_mode == "show") {
			$(".add-links").show(200);
			$(".open-links-button").hide(200);
			$(".close-links-button").show(200);
		} else if (_mode == "hide") {
			$(".add-links").hide(200);
			$(".open-links-button").show(200);
			$(".close-links-button").hide(200);
		}
	}

	async function handleContinueClick(_specialMode = null) {
		console.log('handleContinueClick triggered; "skipBlockchain?" ' + skipBlockchain);
		console.log('Check special mode: ' + _specialMode);
		if (skipBlockchain == false || _specialMode == "team") {
			console.log("Check 1");
			await handleNewOrNotClick('returning'); // 'new' or 'returning'
			// await setupBlockchain('noDataRetrieval'); // Trigger setupBlockchain * * * [disabled 1/10/25]
			$(".new-or-returning").hide(200);
			$(".continue-button").hide(200);
			$(".chain-explanation").hide(200);
			$(".bchain-button-section").show(200);
			if (_specialMode == "team" || teamProject_state == true) {
				console.log("Check 2");
				$(".skip-blockchain-switch").hide(200);
				$(".team-project-notice").show(200);
			}
		} else {
			console.log("Check 3");
			$(".new-or-returning").show(200); // => handleNewOrNotClick button
			$(".continue-button").hide(200);
			$(".user-info-input-section").hide(200);
			$(".input-alert-area").hide(200);
			$(".chain-explanation").hide(200);
			$(".bchain-button-section").hide(200);
			$(".offchain-submit-button").hide(200);
		}
	}

	async function handleNewOrNotClick(_selection) {

		console.log('handleNewOrNotClick()');
		console.log('skipBlockchain ' + skipBlockchain);
		console.log('Selection: ' + _selection);
		// $(".new-or-returning").hide(200);
		// $(".input-alert-area").hide(200); // added 1/15/24
		await resetSubmissionPreferenceArea();
		$(".continue-button").hide();
		$(".chain-explanation").hide();

		if (skipBlockchain == true) { 
			$(".user-info-input-section").show(200);
			if (_selection == 'new') {
				console.log("New off-chain user");
				setRegisterUser(true);
				$(".email-field").show(); // Don't add fade effect
			} else { // 'returning'
				console.log("Returning off-chain user");
				setRegisterUser(false);
				$(".email-field").hide(); // Don't add fade effect
			}
			$(".bchain-button-section").hide(200);
			$(".password-field").show(200);
			$(".offchain-submit-button").show(200);

		} else if (skipBlockchain == false) { 
			console.log("Onchain user");
			// if (selection == 'returning') {
			// 	$(".user-info-section").hide(200);
			// }
			$(".bchain-button-section").show(200);
			$(".password-field").hide(200);
			$(".offchain-submit-button").hide(200);
		}
	}

	// Button - Copy URL & Share
		function copyURL() {
			console.log("Page Address Copied!");
			let currentURL = window.location.href;
			// Remove anchor if present
				currentURL = deleteURLanchor(currentURL);
			setCopyText('Copied!')
			const checkCfm = getURLParameter('cfm');
			let finalURL;
			if (checkCfm != "empty") {
				finalURL = currentURL.replace('&cfm=true', '');
			} else {
				finalURL = currentURL;
				console.log("finalURL: " + finalURL);
			}
			copy(finalURL);

			setTimeout(function() {
				setCopyText('Copy URL & Share');
			}, 3000); // delay of 3 sec
		}


	// File upload

		const HandleUploadStatusChange = e => {
			setFileUploading(current => !current);
			setFileUploaded(current => !current);
		};

		// Display file
			let selectedFile, fileName, fileURL; // GLOBAL
			let btnUpload = $("#upload_file");
			let btnOuter = $(".button_outer");

			const displayFile = (e) => {

				selectedFile = e.target.files[0];
				fileName = btnUpload.val().split('\\').pop();
				let ext = btnUpload.val().split('.').pop().toLowerCase();

				let fileSize = selectedFile.size;
				console.log("File size check: " + fileSize);

				if($.inArray(ext, ['gif','png','jpg','jpeg','pdf']) == -1) {

					$(".error_msg").text("Invalid type (choose jpg, gif, png, or pdf)");

				} else if (fileSize > 20000000) {

					$(".error_msg").text("File is too big. Keep it under 20MB.");

				} else {

					$(".error_msg").text("");
					btnOuter.addClass("file_uploading"); // progress bar
					setTimeout(function(){
						btnOuter.addClass("file_uploaded"); // completion sign
					},1700);

					// selectedFile = e.target.files[0]
					console.log("Check #1: ", selectedFile)
					setFile(selectedFile); // state

					e.target.value = ''; // Needed to allow same file being selected again

					if (ext == 'pdf') {
						fileURL = ASSETS_FOLDER + 'pdf-icon-1.png';
					} else {
						fileURL = URL.createObjectURL(selectedFile); // blob
					}

					setTimeout(function(){ // file image & file name
						$("#uploaded_view").append("<img src='" + fileURL + "' style='margin-top: 20px;' />").addClass("show");
						$("#uploaded_view").append("<p style='color: gray !important; margin-top: 15px; font-size: 14px;'>" + fileName + "</p>");
					},2500);

					setTimeout(function(){ // remove button, progress bar & done sign
						btnOuter.removeClass("file_uploading");
						btnOuter.removeClass("file_uploaded");
						$(".button_outer").hide();
						$(".upload_button").show(); // Show upload button
						$("#file-hashing-info").show();
						$(".vertical-adj-1").show();
						setSubmitBtnDisabled(true);
					},2500);
				}
			}

		// Remove display (this is also in resetUserSubmissionInputSection)
			$(".file_remove").on("click", function(e){
				console.log('reset submission preference area');
				$("#uploaded_view").removeClass("show");
				$("#uploaded_view").find("img").remove();
				$("#uploaded_view").find("p").remove(); // file name
				btnOuter.removeClass("file_uploading");
				btnOuter.removeClass("file_uploaded");
				$(".button_outer").show();
				$(".upload_button").hide();
				$("#loading-motion-1").find("p").remove();
				$("#loading-motion-1").hide(); 
				$(".vertical-adj-1").hide();
				$("#file-hashing-info").hide();
				setSubmitBtnDisabled(false);
				setFile(''); // clear state variable
				setFileHash('') // clear state variable
			});


		// Upload file to Server
			async function handleFileSubmit(e, btn) {
				e.preventDefault();
				console.log("Button ID: " + btn);
				let loadingImgURL = ASSETS_FOLDER + 'loading.gif';

				if (btn == 1) {
					$(".upload_button").hide(); 
					$("#loading-motion-1").show(); 
					$("#loading-motion-1").append("<img width='70px' src='" +loadingImgURL+ "' style='margin-top: -15px;' />");
					$("#file-hashing-info").hide();
					uploadFile(fileSelected);
				}
			}

			async function uploadFile(_fileSelected) {

				// Checking
					console.log("check file selected: ",  _fileSelected);
				// Attached file
					let formData = new FormData();
					formData.append("file", _fileSelected);
					formData.append("uploads_folder", UPLOADS_FOLDER);
		
				axios({
					url: API_ENDPOINT_ROOT + "upload-file.php",
					method: "POST",
					data: formData,
				})
					// Handle the response from backend here
					.then((res) => { 
						console.log("File name: ", res.data.name);
						console.log("File hash: ", res.data.hash);
						setFileNameFinal(res.data.name);
						displayHash(res.data.hash);
					})        
					// Catch errors if any
					.catch((err) => { console.log("error response: " + err) });

				function displayHash(hashValue) {

					setFileHash(hashValue); // state variable

					setTimeout(function() { // time delay applied only when testing (?)

						let displayHash = "Hash:<span style='color: rgba(0,0,0,0);'>|</span>" + hashValue;

						$("#loading-motion-1").find("img").remove();
						setSubmitBtnDisabled(false);

						$("#loading-motion-1").append("<center><p style='margin-bottom: -30px; max-width: 315px; text-align: center; color: rgb(163, 163, 163) !important;'><span style='color: lightgreen; font-weight: bold'> READY </span><br/><span style='overflow-wrap: break-word; font-size: 14px;'>(" + displayHash + ")</p></center>");

						$("#uploaded_view").find("p").remove();

						// window.scrollTo(0, document.body.scrollHeight) // scroll to bottom

					}, 1400); // 3400
				}

			}
	// End of file upload


	// Prepare infoBlockchain text
		let newTabOpenImg = ASSETS_FOLDER + 'ext-link-icon.png';

        const infoBlockchain = "To make your information immutable & irrefutable it needs to be stored on blockchain. To store it on blockchain you need a cyrpto/Web3 wallet installed on your browser or use a wallet app on your mobile device. Then with this wallet you can 1) connect to blockchain, 2) store information onchain, and 3) pay a tiny transaction fee. (Reading from blockchain is free, writing to it is not, though it's so cheap it's practically free.) <br/><br/>If you are new to blockchain and worry that connecting a wallet (Web3 equivalent of 'log in') sounds unsafe, <a href='./faq' target='_blank'>please see FAQ</a> <img src=" + newTabOpenImg + " width='17px'> for more information. Being careful is wise but there's no need to be overly paranoid. <br/><br/>Note: If you already have a wallet with a lot of assets in it, you can create a separate account inside your wallet and use it with Psiscope if you want to feel extra safe.";

	// Blockchain help info show/hide 
		const HandleBchainInfoClick = () => { 

			let bchainInfo = ""; // temp declaration * * *

			if (bchainInfo == false) {
				// setBchainInfo(true);
				$('#blockchain-help-info').html('');
				$('#blockchain-help-info').append(infoBlockchain);
				$('#blockchain-help-info').show(200);
			} else {
				// setBchainInfo(false);
				$('#blockchain-help-info').hide(400);
				$('#blockchain-help-info').html('');
			}
		};


	// Functions for project table

		async function switchPrivateMode() {
			console.log("switchPrivateMode triggered");
			console.log("Check projectKey_state: " + projectKey_state);
			console.log("Check userAddress: " + userAddress);
			console.log("Check privateStatus_state: " + privateStatus_state);

			let privateStatus_ = privateStatus_state;
			if (privateStatus_state == true) {
				privateStatus_ = 0; // reversed
			} else {
				privateStatus_ = 1; // reversed
			}

			// Sign random message
				// Get signature, message, and authenticate user
				const userSignatureInfo = await getSignatureAndAuthenticateUser();
				if (userSignatureInfo == "error") {
					console.log("userSignature request/authentication failed");
					return;
				}

			// Verify signature and insert data to DB
				let postData = {
					type: 'private',
					project_key: projectKey_state,
					bchain_account: userSignatureInfo.account,
					message: userSignatureInfo.message,
					signature: userSignatureInfo.signature,
					private_status: privateStatus_
				};
				axios({ 
					url: API_ENDPOINT_ROOT + "store-data-db.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
					.then((res) => { 
						console.log("DB insertion result: ", res.data.result);
						if (res.data.result && res.data.result != 'error' && res.data.result != 'forbidden') { 
							if (privateStatus_ == 1) {
								console.log("success check 1");
								if (soloProject_state == true) {
									setPrivacyText_state(privacyTextSoloON_state);
								} else if (teamProject_state == true) {
									setPrivacyText_state(privacyTextTeamON_state);
								} else if (openProject_state == true) {
									setPrivacyText_state(privacyTextOpenON_state);
								}
							} else {
								console.log("success check 2");
								setPrivacyText_state(privacyTextOFF_state);
							}
							setPrivateStatus_state(!privateStatus_state);

							setupBlockchain('skip wallet prompt'); // Reset (to re-retrieve data)

						} else if (res.data.result == 'error' || !res.data.result) {
							console.log("error");
							alert("Failed to switch!");
						} else if (res.data.result == 'forbidden') {
							console.log("forbidden");
							alert("You are not allowed to change this setting.");
						}
					}) 
					.catch((err) => { 
						console.log("error response: ", err) 
						alert("Failed to switch!");
					});
		}


		function createRow(_label, _value) {

			let label = _label;
			let value = _value;

			if (label == 'OPEN TIME' || label == 'CLOSE TIME' || label == 'LAUNCHED') {
				if (!value) {
					value = "-----"; 
				} else { // Convert UNIX time to UTC
					// console.log("Check date: " + _value);
					if (label == 'LAUNCHED') {
						value = new Date(Number(_value * 1000));
					} else {
						value = new Date(Number(_value));
					}
					value = value.toISOString();
					value = value.slice(0, 16).replace('T', ' ');
					if (_value == 0) { // if null
						value = "-----";
					} else {
						value = value + " (UTC)";
					}
				}
			}

			if (label == 'PROJECT FOR') {

				if (_value == restrictionOpenHash) {
					value = "ALL (open project)"; // used in if statement later also
				} else if (_value == restrictionSoloHash) {
					value = "YOU only"; // used in if statement later also
				} else if (_value) { // This would be the team key
					value = "TEAM ";
				} else if (!_value) {
					value = "-----"; 
				}
			}

			if (label == "FILE HASH" || label == "PROJ MANAGER") {
				if (!value) {
					value = "-----"; 
				}
			}
			return { label, value };
		}

	// For Project info table

	let rows = []; // global
	rows = [ // Set row labels and values
		// createRow('PROJ MANAGER', projectInfo_onchain.managerName),
		createRow('PROJ MANAGER', finalManagerName),
		// createRow('MANAGER ADDR', projectInfo_onchain.managerAddress),
		createRow('PROJECT FOR', projectInfo_onchain.restriction),
		// createRow('PRIVATE MODE', projectInfo_offchain.private), 
		createRow('OPEN TIME', projectInfo_onchain.openTime),
		createRow('CLOSE TIME', projectInfo_onchain.closeTime),
		createRow('LAUNCHED', projectInfo_onchain.timeStamp),
		// createRow('FILE HASH', projectInfo_onchain.projectFileHash),
		createRow('PROJECT KEY', projectKey_state),
		createRow('PROJECT TXN', '')
	];
		
	// Set dark theme
    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
        },
    });
	// Set dim theme
		const dimtheme = createTheme({
			palette: {
				neutral: {
					main: 'rgb(171, 171, 171)',
					contrastText: '#fff',
				},
			},
		});


	// For collapsible table - - - - -

		async function prepareTable2Data(_data) {
			console.log("prepareTable2Data triggered");
			console.log("Submissions array from contract: ", _data);
			// console.log("Check state submissionTxHash: " + submissionTxHash);

			const projectKey = getURLParameter('key');

			// Check if project is closed
				const returnedFeedbackInfo = await getProjectFeedbackFromDB_AndSetStateVars(projectKey);
				const projectState = returnedFeedbackInfo.project_state;

			let allSubmissions_onchain_DB = null;
			if (_data !== 'empty') {
				// Get all ON-chain submissions from DB (for original psi data text, file name, txn hash & latest username)
				console.log("Calling getSubmissionsArray_onchain_DB");
				allSubmissions_onchain_DB = await getSubmissionsArray_onchain_DB(projectKey);
				console.log("Check getSubmissionsArray_onchain_DB: ", allSubmissions_onchain_DB);
				setSubmissionsArrayDB(allSubmissions_onchain_DB);
			}
			// Get all OFF-chain submissions from DB
				console.log("Calling getSubmissionsArray_offchain_DB");
				const allSubmissions_offchain = await getSubmissionsArray_offchain_DB(projectKey);
				console.log("Check allSubmissions_offchain: ", allSubmissions_offchain);

			// Verify data by hashing string, and comparing it with hash
				
			let userPsiDataText, userFile, checkedUsername;
			let dataIsOnchain;
			let table2Rows = []; let table2Rows_offchain = [];
			// let table2Rows = [...rows2]; // unnecessary?

			if (_data !== 'empty' && allSubmissions_onchain_DB) { 
				// If any onchain submissions found
				for (let i = 0; i < _data.length; i++) {

					// console.log("Check data length: ", _data.length);
					dataIsOnchain = true;

					if (allSubmissions_onchain_DB.file_name[i]) {
						userFile = UPLOADS_FOLDER + allSubmissions_onchain_DB.file_name[i];
					}

					// Make sure the latst username is included in the table
					console.log("Make sure to use the latest username");
						console.log("Username from DB: ", allSubmissions_onchain_DB.username[i]);
						console.log("Username from blockchain: ", _data[i].userName);
						
					if (allSubmissions_onchain_DB.username[i]) {
						if (allSubmissions_onchain_DB.username[i] !== _data[i].userName) {
							console.log("Username from DB is used");
							checkedUsername = allSubmissions_onchain_DB.username[i];
						} else {
							console.log("Username from blockchain is used");
							checkedUsername = _data[i].userName;
						}
					} else {
						console.log("Username from blockchain is used");
						checkedUsername = _data[i].userName;
					}

					// Use original data if project is closed, hashed if open
					if (projectState == 'closed') {
						console.log("Project closed");

						// Get original submission text
							const userPsiDataText_orig = allSubmissions_onchain_DB.original_submission[i];

						// Validate data by comparing it to its hash stored onchain
							// Psi info text
							const hashVerified_1 = await compareHash(_data[i].userPsiData, userPsiDataText_orig);

							if (hashVerified_1 == false) { // If they don't match...
								console.log("The hash did not match the provided text!");
								userPsiDataText = "[INVALID DATA - Provided text did not match onchain hash]";

							} else { // If they match, format & sanitize the text for HTML display
								console.log("Hash verified"); 
								const formattedPsiDataText = userPsiDataText_orig.replace(/\n/g, '<br/>');
								userPsiDataText = DOMPurify.sanitize(formattedPsiDataText);
							}

							// File
							if (_data[i].userFileHash) {
								const hashVerified_2 = await validateFileHash(_data[i].userFileHash, userFile);
								if (hashVerified_2 == false) {
									console.log("The hash did not match the provided file!");
									userFile = "[INVALID FILE - Provided file did not match onchain hash]";
								} else { console.log("Hash verified"); }
							}

					} else {
						console.log("Project open");
						userPsiDataText = _data[i].userPsiData; // Hashed
					}

					const table2Data = createData(
						dataIsOnchain,
						i, // index number
						// _data[i].userName, 
						checkedUsername,
						_data[i].userTimeStamp.toNumber(),
						_data[i].userAddress,
						userPsiDataText,
						_data[i].userFileHash,
						allSubmissions_onchain_DB.file_name[i], // 'Forbidden' if proj still open
						allSubmissions_onchain_DB.tx_hash[i]
					);
					console.log("Check table2Data: ", table2Data);
					table2Rows.push(table2Data);
				}
			}  
			
			if (allSubmissions_offchain) { // If any offchain submissions found

				console.log("Check offchain submissions length: ", allSubmissions_offchain.username.length);
				dataIsOnchain = false;

				for (let i = 0; i < allSubmissions_offchain.username.length; i++) {

					// Use original data if project is closed, hashed if open
					if (projectState == 'closed') {
						console.log("Project closed");
						userPsiDataText = allSubmissions_offchain.original_submission[i];
					} else {
						console.log("Project open");
						userPsiDataText = allSubmissions_offchain.hashed_submission[i];
					}

					const noUserAddress = "Off-chain - no address";
					const noTxnHash = "Off-chain - no transaction";
					let UNIXTimeStamp = convertToUNIXTime(allSubmissions_offchain.submission_time[i]);
					UNIXTimeStamp = UNIXTimeStamp / 1000; // convert to seconds

					const table2Data_offchain = createData(
						dataIsOnchain,
						i, // index number
						allSubmissions_offchain.username[i], 
						UNIXTimeStamp,
						noUserAddress, // "Off-chain - no address"
						userPsiDataText,
						allSubmissions_offchain.file_hash[i],
						allSubmissions_offchain.file_name[i], //'Forbidden' if proj still open
						noTxnHash // "Off-chain - no transaction"
					);
					console.log("Check table2Data_offchain: ", table2Data_offchain);
					table2Rows_offchain.push(table2Data_offchain);
				}
			} 
			
			if (_data === 'empty' && table2Rows_offchain.length == 0) {
				console.log("No submissions found");
				const table2Data = createData(
					"missing",
					0, // index number
					"-----",
					"-----",
					"",
					"",
					"",
					"",
					""
				);
				table2Rows.push(table2Data);

			} else {

				console.log("Merge table2Rows and table2Rows_offchain");
				// Combine table2Rows and table2Rows_offchain and order them based on timestamp

				table2Rows = table2Rows.concat(table2Rows_offchain);
				table2Rows.sort((a, b) => b.timeStamp - a.timeStamp);
				console.log("Check table2Rows: ", table2Rows);
				// Set readable time of data just submitted
					let firstRowReadableDate;
					if (table2Rows.length > 0) {
						firstRowReadableDate = table2Rows[0].readableDate;
						setJustSubmittedReadableTime(firstRowReadableDate); // Set readable time of data just submitted
					}
					console.log("justSubmittedReadableTime: " + firstRowReadableDate);
			}

			console.log("Check projectClosed: ", projectClosed);

			setRows2(table2Rows); // Set rows for collapsible table * * *
			
		} // End of prepareTable2Data()
		

		function createData(dataIsOnchain, indexNum, username, timeStamp, userAddress, psidata, fileHash, fileName, txnHash) {

			// Format date (make it readable UTC time)
				let readableDate;
				let readableTime; // time down including seconds
				if (timeStamp !== "-----") {
					let date = new Date(timeStamp * 1000);

					readableDate = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}`;

					readableTime = `${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;

				} else {
					readableDate = "-----";
					readableTime = "-----";
				}
		
			return {
				dataIsOnchain,
				indexNum,
				username,
				timeStamp,
				readableDate,
				readableTime,
				userAddress,
				psidata,
				fileHash,
				fileName, // 'Forbidden' if project still open
				txnHash,
			};
		}

		Row.propTypes = {
			table2Row: PropTypes.shape({
				username: PropTypes.string.isRequired,
				readableDate: PropTypes.string.isRequired,
				readableTime: PropTypes.string.isRequired,
			}).isRequired,
		};

		
		function Row(props) { // This component is for collapsible table (props from mapping done within the table section)
			const { rowReadableTime, table2Row, showLatestSubmission } = props;
			// console.log("rowReadableTime:" + rowReadableTime);
			// console.log("table2Row - right before update", table2Row);
			const [rowOpen, setRowOpen] = useState(false);
			// setRowOpen(false);

			// console.log("Check showLatestSubmission: ", showLatestSubmission);
			useEffect(() => {
				if (!showLatestSubmission) {
					// console.log("TEST CHECK 1 * * *");
					setRowOpen(false);
				} else if (justSubmittedReadableTime == rowReadableTime) {
					// console.log("TEST CHECK 2 * * *");
					setRowOpen(true);
				}
			}, []);
		
			return (
				<React.Fragment>

					<TableRow sx={{ '& > *': { borderBottom: 'unset' } }} style={{ cursor: 'pointer' }} onClick={() => setRowOpen(!rowOpen)} >
						<TableCell>
							<IconButton
								aria-label="expand row"
								size="small"
								onClick={() => setRowOpen(!rowOpen)}
							>
								{rowOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
							</IconButton>
						</TableCell>
						<TableCell component="th" scope="row" style={{ border:"0px solid red", minWidth:'100px', overflowWrap: 'break-word'}}>
							{table2Row.username}
						</TableCell>
						<TableCell component="th" scope="row" align="center" style={{borderBottom: 'unset'}}>
							{table2Row.readableDate}
						</TableCell>
						<TableCell component="th" scope="row" align="center" style={{borderBottom: 'unset'}}>
							{ table2Row.dataIsOnchain == true ? (
								<div style={{ color:'rgb(165, 255, 153)' }}>Yes</div>
							) : ( 
								table2Row.dataIsOnchain != "missing" ? (
									<div style={{ color:'rgb(212, 212, 212)' }}>No</div>
								) : (
									<div>-----</div>
								)
							)}
						</TableCell>
					</TableRow>

					{/* Hidden row */}
					<TableRow>
						{ table2Row.username == "-----" ? ( //Empty if no submissions found

							""

						) : ( // Show data if submissions found
							<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
								<Collapse in={rowOpen} timeout="auto" unmountOnExit>
									<Box sx={{ margin: 1 }}>

										<Typography variant="h6" gutterBottom component="div" style={{ margin:'0px 0px -8px 13px', color:'rgb(196, 143, 217)', fontSize:'15px', fontWeight:'bold' }}>
											<div>- User Address: </div>
										</Typography>

										<Table style={{ marginLeft:'8px', marginBottom:'4px'}}>
											<TableBody>
												<TableRow>
													<TableCell style={{ borderBottom: 'unset', margin:'0px 0px 0px 0px', lineHeight:'1.8', wordBreak: 'break-word', color:'rgb(207, 207, 207)' }} >
														<div className = 'width-control-3'>
															{table2Row.userAddress}
														</div>
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
										
										<Typography gutterBottom component="div" style={{ margin:'-3px 0px 1px 13px', color:'rgb(196, 143, 217)', fontSize:'15px', fontWeight:'bold', wordBreak:'break-word' }}>
											<div>- Psi Data:</div>

											{ projectClosed == false ? (
												<div style={{ marginTop:'8px', marginBottom:'-7px', marginLeft:'9px', color:'rgb(255, 153, 153)', fontSize:'15px', fontWeight:'normal' }}>
													(Hashed until project closes)
												</div>
											) : (
												""
											)}
										</Typography>

										<Table size="small" aria-label="purchases" style={{ marginLeft:'8px', marginBottom:'11px'}}>
											<TableBody>
												<TableRow>
													<TableCell style={{borderBottom: 'unset', lineHeight:'1.8', wordBreak: 'break-word'}} >
														{ projectClosed == false ? (
															<div className='width-control-3' style={{ fontSize:'14px', color:'rgb(207, 207, 207)', wordBreak: 'break-word' }}>
																{table2Row.psidata}
															</div>
														) : (
															<div className='width-control-3' style={{ fontSize:'15px', wordBreak: 'break-word' }}>

																{/* {table2Row.psidata} */}

																<div dangerouslySetInnerHTML={{ __html: table2Row.psidata }} />

															</div>
														)}
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>

										{ table2Row.fileHash ? (
											<Typography gutterBottom component="div" style={{ marginLeft:'13px', marginBottom:'3px', color:'rgb(196, 143, 217)', fontSize:'15px', fontWeight:'bold' }}>
												<div>- Uploaded File:</div>
												{ projectClosed == false ? (
													<div style={{ marginTop:'8px', marginBottom:'-7px', marginLeft:'9px', color:'rgb(255, 153, 153)', fontSize:'15px', fontWeight:'normal' }}>
														(Hashed until project closes)
													</div>
												) : (
													""
												)}
											</Typography>
										) : (
											""
										)}

										{ table2Row.fileHash ? (
											<Table size="small" aria-label="purchases" style={{ marginLeft:'3px'}}>
												<TableBody>
													<TableRow>
														<TableCell align="left" style={{borderBottom: 'unset'}}>
															{ projectClosed == false ? (
																<div className='width-control-3' style={{ fontSize:'14px', color:'rgb(207, 207, 207)', marginBottom:'18px', marginLeft:'4px', wordBreak: 'break-word' }}>
																	{table2Row.fileHash}
																</div>
															) : (
																<Button variant="outlined" size="small" style={{ margin:'5px 0px 21px 4px' }} onClick={ ()=> openFileLink(table2Row.indexNum, table2Row.dataIsOnchain) }>
																	Open File
																</Button>
															)}
														</TableCell>
													</TableRow>
												</TableBody>
											</Table>
										) : (
											""
										)}

										<Typography variant="h6" gutterBottom component="div" style={{ margin:'-4px 0px -8px 13px', color:'rgb(196, 143, 217)', fontSize:'15px', fontWeight:'bold' }}>
											<div>- Transaction Link: </div>
										</Typography>

										<Table style={{ marginLeft:'8px', marginBottom:'4px'}}>
											<TableBody style={{ display:'inline-block' }}>
												<TableRow>
													<TableCell style={{ borderBottom: 'unset', lineHeight:'1.8', wordBreak: 'break-word', color:'rgb(207, 207, 207)' }} >
														{ table2Row.dataIsOnchain == true ? (

															<a href={BLOCK_EXPLORER_URL + table2Row.txnHash} target="_blank" rel="noopener noreferrer">
																<Button variant="outlined" size="small" style={{ margin:'5px 0px 25px 1px' }}>
																	Txn Link
																</Button>
															</a>

														) : (
															<div>{table2Row.txnHash}</div>
														)}

													</TableCell>

													{ table2Row.dataIsOnchain == true ? ( 
														<div style={{ 
															border:'0px solid red',
															marginLeft:'-5px', marginTop:'25px', fontSize:'14px', display:'inline-block'}}>

															[ <a href='https://psiscope.com/how-to-audit-project-type-1-onchain-data/' target='_blank'>
																How to check
															</a> ]<br/>
														</div>

													) : ( 
														""
													)}

												</TableRow>
											</TableBody>
										</Table>
										
									</Box><br/>
								</Collapse>
							</TableCell>
						)}
					</TableRow>
				</React.Fragment>
			);
		}

		const instruction_ShortText = "This project has a 'tasker' or 'project manager' who has set up a hidden 'target' (objective). You are to use your PSYCHIC ABILITY to perceive the 'target' without any clues. The target can be anything - a person, place, thing or event. Use whatever technique you want and submit your psychic impresssions via a form below. (You may attatch a PDF or image file).";

		const instruction_FullText = "This project has a 'tasker' or 'project manager' who has set up a hidden 'target' (objective). You are to use your PSYCHIC ABILITY to perceive the 'target' without any clues. The target can be anything - a person, place, thing or event. Use whatever technique you want and submit your psychic impresssions via a form below. (You may attatch a PDF or image file). <br/><br/> You are encouraged to use blockchain when submitting your data. Blockchain technology makes your data permanent, immutable, publicly verifiable, time-stamped, and 'signed' by you. In the digital realm, especially now with the advent of A.I., blockchain technology is the only way to make sure your information is truly verifiable (i.e. what information was recorded by whom and when). <br/><br/> If you choose to use blockchain, you will be asked to connect your Web3 wallet such as Metamask to Psiscope (this site/project) and then make a transaction during the submission process which requires a <em>tiny</em> fee or 'gas' (~$0.01 USD) which is purely for the cost of storing data on the blockchain. The fee goes direclty and fully to the blockchain network itself, which is just how all public blockchains work. (Please see <a style='color: rgb(154, 209, 255);' href='/faq' target='_blank'>FAQ</a> for more information.) <br/><br/> If you choose not to use blockchain, your psi data will be stored off-chain in a database on a server which won't be tamper-proof and thus won't be considered 'official'. The off-chain route is for you to check things out before diving fully into the onchain, Web3 way of doing this.<br/><br/> The secret tasking for this project has already been recorded on blockchain thereby making it PERMANENT and IMMUTABLE. Cheating is already <em>impossible</em> on the tasking/feedback side. To achieve a simultaneously verifiable and blind condition, only the cryptographic 'fingerprint' or 'hash' of the tasking text has been recorded and is displayed. The tasking will remain indecipherable until the original text is revealed at the conclusion of the project. Once the orignal text is revealed, it can be authentificated by hashing it again and then comparing to the original hash. If authentic, they should match.";

		const feedbackNote_ShortText = "This project is past deadline and is closed. The tasking/target along with all information submitted by participants is now revealed below.";

		const feedbackNote_FullText = "This project is past deadline and is closed. The tasking/target along with all information submitted by participants is now revealed below. <br/><br/> This was a psi/remote viewing/ESP project involving a 'tasker' and a group of participants tasked to use their psychic sense to perceive a 'target' which remained hidden until the project closed. <br/><br/> Participants were encouraged to use blockchain when submitting data as this would make the information permanent, immutable, public, time-stamped, and 'signed' by the participant. In the digital realm, especially now with the advent of A.I., blockchain technology is the only way to make any information truly verifiable in terms of what information was recorded by whom and when. <br/><br/> Psi impressions submitted without blockchain are stored off-chain in a database on a server and is not considered 'official'.<br/><br/> The secret tasking for this project was recorded 'onchain' at the start thereby making it PERMANENT and IMMUTABLE. Only the cryptographic 'fingerprint' or 'hash' of the tasking text was recorded and was displayed, making it verifiable yet indecipherable until the original text was revealed by the tasker at the end. Once the orignal tasking text is revealed, its authenticity can be verified by hashing it again and then comparing to the hash recorded on blockchain. If authentic, the hashes are identical.";



// - - - - - -

	return (

    <div className="App-container">

		<ThemeProvider theme={darkTheme}>

			{/* <div className="container" style={{border: "0px solid darkgray"}}> */}

			{/* Mobile Nav Buttons*/}

				<div className="mobile-nav-buttons" style={{border:"0px solid red", margin:"auto", marginTop:"-15px", display:"none"}}>

					<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"5px", marginTop:'17px'}} onClick={ () => setupBlockchain('skip wallet prompt') }>
						<Link className="nav-menu-mobile" to="/create" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Create</Link>
					</Button>

					 <div style={{ color:'gray', display:'inline-block' }}>|</div> 

					<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"3px", marginTop:'17px'}}>
						<Link className="nav-menu-mobile" to="/browse" style={{ fontSize:'16px', fontWeight:'normal', color:'white'}}>Browse</Link>
					</Button>

					<div style={{ color:'gray', display:'inline-block' }}>|</div> 

					<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"-5px", marginTop:'17px'}}>
						<Link className="nav-menu-mobile" to="/faq" style={{ fontSize:'16px', fontWeight:'normal', color:'white'}}>FAQ
						</Link>
					</Button>
				</div>

			<div className="app-title" style={{ margin:"13px 0px 0px" }}>
				PROJECT TYPE-1
			</div>

		{/* GRAY BOX*/}

            <div style={{ margin:"auto", marginTop: '30px', marginBottom:"-20px", maxWidth:'670px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025)', padding:'15px', paddingTop:'35px', paddingBottom:'50px' }}>

			{/* Project TRN */}
			{feedbackShown == false ? (
				<div className='header-texts heading' style={{ margin:'4px 0px 5px', maxWidth:'640px' }}>
					{projectRefNumber}
				</div>
			) : (
				<div className='header-texts heading' style={{ border:'0px solid red', margin:'4px 0px 5px', maxWidth:'640px' }}>
					{feedbackTitle}
				</div>
			)}

			{/* Project title and/or TRN, and project status */}
			{feedbackShown == false ? (

				<div className='header-texts' style={{ margin:'4px 0px 10px', maxWidth:'640px', color: 'rgb(148, 148, 148)', fontFamily:'Oxanium', fontWeight: 'normal', fontSize: '22px', wordBreak: 'break-word', lineHeight: 1.3 }}>

					[Tasking Reference Number]

					<div className='header-status-note' style={{ marginTop:'15px', color:'lightgreen', fontSize:'17px', display:'none'}}>

						{ projectInfo_onchain.timeStamp ? (
							projectWaiting == false ? (
								teamProject_state == true ? (
									"For Team - \"" + projectInfo_offchain.team_name + "\""
								) : (
									privateStatus_state == true ? (
										<div style={{ color:'lightred'}}>Project Is Private</div>
									) : (
										"Open To All"
									)
								)
							) : (
								<div style={{ marginTop:'5px', color:'yellow', fontSize:'17px'}}>
									Not Yet Open
								</div>
							)
						) : (
							notConnectedToBchain == true ? (
								<div style={{ marginTop:'15px', color:'rgb(245, 71, 71)', fontSize:'17px'}}>Failed to Connect to Blockchain<br/>
								<span style={{ marginTop:'15px', color:'rgb(176, 176, 176)', fontSize:'15px'}}>(Please connect or retry later)</span></div>
							) : (
								<div style={{ marginTop:'15px', color:'rgb(245, 71, 71)', fontSize:'17px'}}>Project can't be displayed (no blockchain connection?)</div>
							)
						)}
					</div>
				</div>
			) : (
				<div className='header-texts' style={{ margin:'4px 0px 10px', maxWidth:'640px', color: 'rgb(181, 181, 181)', fontFamily:'Oxanium', fontWeight: 'normal', fontSize: '26px', wordBreak: 'break-word', lineHeight: 1.3 }}>
					TRN: {projectRefNumber}
					<div style={{ marginTop:'15px', color:'rgb(204, 88, 88)', fontSize:'17px'}}>
						Closed
					</div>
				</div>
			)}		


			{/* -------------------------------- */}

			<br/><br/>

			{/* Inner gray box - Signature request */}

				<div className='signature-request-section' style={{ margin:"auto", marginBottom:"30px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px', display: 'none' }}>
					<br/>
					<div className='subheading' style={{ marginBottom:'20px', fontSize:'22px' }}>
						SIGNATURE REQUEST
					</div>

					<div style={{maxWidth: '570px', margin:'auto', marginTop: '11px', marginBottom: '18px', color: 'rgb(211, 211, 211)', lineHeight: '1.5', textAlign:'left' }}>
						This project is 'private'. To open, your "signature" is required. (You also need to be pre-approved by the project.) Please connect your Web3 wallet (e.g. Metamask) and "sign" the message.
					</div>


				{/* Connect BLOCKCHAIN button - for signature */}

					<center className='connect-wallet-button-sig' style={{ marginTop:'30px', marginBottom:'30px', display:'block' }}>

						<div className='vertical-adj-1' style={{display: 'none'}}></div>

						<Button className='bchain-button' variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ submitBtnDisabled } onClick={() => checkUserCredentialsForPrivateInfo()}>
							Verify Your Identity
						</Button>

						<Button className='connect-wallet-button' variant='contained' style={{backgroundColor: 'rgb(207, 154, 151)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ submitBtnDisabled } onClick={ connectWallet }>
							Connect (Blockchain)
						</Button>

						<Button className='switch-chain-button' variant='contained' style={{backgroundColor: 'rgb(239, 223, 143)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ submitBtnDisabled } onClick={ switchNetwork }>
							Switch Network
						</Button>

						{/* <Box className='bchain-progress' style={{display: 'none'}}>
							<br/><div style={{ color:'white'}}>Please wait...</div><br/>
							<CircularProgress />
						</Box> */}

						{/* Blockchain help text */} 

					</center>					

					{/* --------------- */}


				</div>


			{/* Inner gray box */}

				<div className={'basic-instruction-section main-boxes'} style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px' }}>
					<br/>
					<div className='subheading' style={{ marginBottom:'20px', fontSize:'22px' }}>
					{feedbackShown == false ? (
						"GENERAL INSTRUCTION"
					) : (
						"N O T E"
					)}
					</div>

					<div style={{maxWidth: '570px', margin:'auto', marginTop: '11px', marginBottom: '18px', color: 'rgb(211, 211, 211)', lineHeight: '1.5', textAlign:'left' }}>

						{isExpanded ? (
							feedbackShown == false ? (
								<div dangerouslySetInnerHTML={{ __html: instruction_FullText }} />
							) : (
								<div dangerouslySetInnerHTML={{ __html: feedbackNote_FullText }} />
							)
						) : (
							feedbackShown == false ? (
								<div dangerouslySetInnerHTML={{ __html: instruction_ShortText }} />
							) : (
								<div dangerouslySetInnerHTML={{ __html: feedbackNote_ShortText }} />
							)
						)}
						<a onClick={() => setIsExpanded(!isExpanded)}>
							{isExpanded ? (
								<span style={{ color:'rgb(154, 209, 255)', fontWeight:'normal', cursor:'pointer' }}>&lt;&lt; Read Less</span>
							) : ( 
								<span style={{ color:'rgb(154, 209, 255)', fontWeight:'normal', cursor:'pointer' }}>Read More &gt;&gt;</span>
							)}
						</a>

					</div>
				</div>


			{/* horizontal line */}
				<center>
					<div className='width-control-1 main-boxes' style={{margin: 'auto', margin: '40px 0px 40px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '635px', display: feedbackShown == false && projectWaiting == false ? 'block' : 'none'}}></div>
				</center>

			{/* Inner gray box */}
			{/* display: userIsManager_state == true ? 'block' : 'none' */}

				{ feedbackShown == true && mainBoxesVisible == true && (showUpdateBox == true || userIsManager_state == true) ? (

					<div className='' style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px 18px 30px' }}>

						<div ref={sectionRef} className='subheading' style={{ marginTop: '20px', marginBottom:'0px', fontSize:'22px' }}>U P D A T E</div>

						{/* Manager setting section */}

						<div style={{display: userIsManager_state == true ? 'block' : 'none' }}>
							<div style={{ marginTop:'20px', marginRight:'6px', color:'rgb(131, 214, 185)', display:'inline-block' }}>Make update public: </div>

							<div style={{ marginBottom:'5px', display:'inline-block'}}>
								<FormGroup 
									sx={{
										'& > :not(style)': { m: 0 },
										border: '0px solid blue'
									}}>

									<FormControlLabel style={{ color: "lightgray", display:'inline-block' }}
									control={<Switch 
										size="small" 
										checked={showUpdateBox} 
										onChange={handleUpdateBoxSwitch} />} 
										label="" />
								</FormGroup>
							</div><br/>
							
							<Button onClick={() => setOpenEdit(prev => !prev)} display={{ display:'' }}>
								{ openEdit == true ? "Close Edit Mode " : "Add / Edit Update " }
							</Button>
						</div>

						{/* "Update" Text display section */}

						<Collapse in={!openEdit}>
							<Box
								// className={showUpdateEditBox ? 'show' : 'hide'}
								sx={{
									'& > :not(style)': { m: 0 },
									margin: "auto",
									marginTop: '30px',
									marginBottom: '-25px', // Use this for gap below note text when not in edit mode
									backgroundColor: 'rgba(69, 69, 69, 0.6)',
									padding: '18px',
									color: 'rgb(240, 240, 240)', 
									lineHeight: '1.5', 
									textAlign:'left'
								}}
								noValidate
							>

								{updateText ? (
									<div dangerouslySetInnerHTML={{ __html: updateText }} />
								) : (
									<center style={{ color:'rgb(148, 148, 148)'}}>[empty]</center>
								)}

							</Box>
						</Collapse>

						{/* "Update" note text edit section */}

						<Collapse in={openEdit}>

							<Typography variant="h6" gutterBottom style={{ marginTop:'35px', color: 'rgb(155, 155, 155)', fontSize: '17px' }}>
								Add / Edit Text
							</Typography>

							<Box
								sx={{
									'& > :not(style)': { m: 0.5 },
									// maxWidth: '467px',
									margin: "auto",
									marginTop: '10px',
									marginBottom: '-15px', // was 25
									backgroundColor: 'rgba(67, 67, 67, 0.6)',
									p: 2,
									borderRadius: 2
								}}
								noValidate
							>
									
								<Box
									// className={showUpdateEditBox ? 'show' : 'hide'}
									sx={{
										'& > :not(style)': { m: 0 },
										// maxWidth: '495px',
										margin: "auto",
										marginTop: '30px',
										// backgroundColor: 'rgba(64, 64, 64, 0.6)'
										backgroundColor: 'rgba(50, 50, 50, 0.6)'
									}}
									noValidate
								>
									<TextField 
										// error={errorUpdateText}
										// required={true}
										fullWidth
										id="update-textarea"
										value={updateText}
										label={updateText === "" ? "Write your update here" : ""}
										multiline
										rows={4}
										onChange={(event) => {handleUpdateTextFormChange(event.target.value)}}
									/>
								</Box>
							</Box>
						</Collapse>


						{/* URL Notes Section */}

						<Box sx={{ border:'0px solid red', margin: "auto", marginTop: '45px' }}>

							<Typography variant="h6" gutterBottom style={{ color: 'rgb(155, 155, 155)', fontSize: '17px'}}>

								{ openEdit == true ? "Add / Edit Links" : "" }

							</Typography>

							{/* URL note/link display/edit section */}

							<Collapse in={openEdit}>

								<Box
									sx={{
										'& > :not(style)': { m: 0.5 },
										// border: '1px solid red',
										// maxWidth: '495px', // 495
										margin: "auto",
										marginTop: '0px',
										// marginBottom: '0x', // was 50
										backgroundColor: 'rgba(69, 69, 69, 0.6)',
										p: 2,
										borderRadius: 2
									}}
									noValidate
								>
									<TextField
										fullWidth
										label='URL (like "https://cnn.com")'
										name="link"
										value={urlNoteForm.link}
										multiline
										onChange={handleLinkFormChange}
										// required
										sx={{ 
											mb: 2, 
											backgroundColor: 'rgba(50, 50, 50, 0.6)' 
										}}
									/>
									<TextField
										fullWidth
										label="Short Description"
										name="note"
										value={urlNoteForm.note}
										multiline
										onChange={handleLinkFormChange}
										// required
										sx={{ 
											mb: 2,
											backgroundColor: 'rgba(50, 50, 50, 0.6)' 
										}}
										style={{ marginTop: '15px', fontWeight: 'bold' }}
									/>
									<Button
										variant="outlined"
										onClick={handleLinkFormSubmit}
										fullWidth
										style={{ marginTop: '25px' }}
									>
										{editingIndex !== null ? "Update Link" : "Add Link"}
									</Button>
								</Box>
							</Collapse>


							{/* Vertical gap adjustment if not in edit mode */}
								{ !openEdit ? (<div style={{ marginTop: '-25px' }}></div>) : (<div style={{ marginTop: '35px' }}></div>) }

							<List 
								sx={{ 
									mt: 2, 
									marginTop: '23px',
									marginBottom: '0px',
									mx: "auto" 
								}}
							>
								{urlNotesArray.map((item, index) => (
									<ListItem
										key={index}
										sx={{
											backgroundColor: "rgba(69, 69, 69, 0.6)",
											borderRadius: 2,
											mb: 1,
											px: 2,
											py: 1.5,
											display: "flex",
											flexDirection: "column",
											alignItems: "stretch",
											color: "white"
										}}
									>
										<Box
											sx={{
												width: "100%",
												display: "flex",
												justifyContent: "space-between",
												alignItems: "flex-start",
												gap: 2
											}}
										>
											{/* Text + link column */}
											<Box sx={{ flex: 1 }}>
												<Typography
													variant="body1"
													sx={{
														fontWeight: 400,
														fontSize: '16px',
														color: "lightgray",
														wordBreak: "break-word"
													}}
												>
													<Button
														variant="outlined"
														size="small"

														href={item.link}

														target="_blank"
														rel="noopener noreferrer"
														sx={{
															marginTop:'0px',
															float: "left",
															mr: 2,
															mb: 1,
															textTransform: "none"
														}}
													>
														OPEN LINK
													</Button>

													{item.note}

												</Typography>
											</Box>

											{/* Always vertically stacked buttons */}
											{openEdit && (
												<Box
													sx={{
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-end",
													gap: 0.5
													}}
												>
													<Button
													size="small"
													variant="text"
													onClick={() => handleEdit(index)}
													sx={{ color: "#64b5f6", px: 1, minWidth: 0 }}
													>
														EDIT
													</Button>
													<Button
													size="small"
													variant="text"
													onClick={() => handleDelete(index)}
													sx={{ color: "#f44336", px: 1, minWidth: 0 }}
													>
														DELETE
													</Button>
												</Box>
											)}
										</Box>
									</ListItem>
								))}
							</List>
						</Box>

						<Collapse in={openEdit}>
							{/* Vertical gap adjustment if URL notes exist */}
								{ urlNotesArray.length !== 0 ? (<div style={{ marginTop: '40px' }}></div>) : ("") };

							<Button className='' variant='contained' style={{ marginTop:'0px', fontWeight: 'bold', color: 'rgb(47, 70, 117)' }} onClick={ handleProjectUpdateSubmit }>
								Save & Close
							</Button>

						</Collapse>

					</div>
				) : ( "" )}

			
			{/* horizontal line - BELOW UPDATE section */}

				{ feedbackShown == true && (showUpdateBox == true || userIsManager_state == true) ? (
					<center>
						<div className={'width-control-1 main-boxes'} style={{margin: 'auto', margin: '38px 0px 38px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '635px'}}></div>
					</center>
				) : ( "" )}


			{/* Inner gray box */}

			<div className='data-submission-section' style={{ marginTop:'0px', display: mainBoxesVisible == true ? 'block' : 'none'}}>

			<div style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px', display: (feedbackShown == false && projectWaiting == false) ? 'block' : 'none'}}>

			<div style={{ display: projectWaiting == false ? 'block' : 'none'}}>

				<br/>
				<div className='subheading' style={{ marginBottom:'20px', fontSize:'22px' }}>SUBMIT YOUR PSI DATA</div>

				<Box
					sx={{
						'& > :not(style)': { m: 0 },
						maxWidth: 495,
						// padding: '15px',
						margin: "auto",
						marginTop: "30px",
						marginBottom: "-55px",
						backgroundColor: 'rgba(64, 64, 64, 0.6)'
					}}
					noValidate
				>
					<TextField 
						error={errorPsiSubmissionText}
						// required={true}
						fullWidth
						id="submission-textarea"
						value={psiSubmissionText}
						label="Enter your psi impressions"
						multiline
						rows={4}
						onChange={(event) => {setPsiSubmissionText(event.target.value)}}
					/>
				</Box>


				{/* Upload file button */}

					<div className="panel" style={{ marginTop:"85px", marginBottom:"-90px" }}>

						<div id="file-hashing-info" style={{margin: 'auto', marginTop: '50px', marginBottom: '-10px', color: 'lightgray', fontSize: '14px', textAlign: 'left', maxWidth: '420px', display: 'none'}}>{infoHashingFile}</div>

						{/* Adjust margins in button style below for spacing between uploading gif/"Ready"/hash and file display */}
						<Button className="upload_button" variant="outlined" size="large" style={{ margin: "auto", marginTop:'25px', marginBottom:'70px', fontWeight: "bold", display: "none"}} onClick={(e) => handleFileSubmit(e, 1)} >Click to Confirm</Button>

						<div id="loading-motion-1" style={{ margin:'10px 0px 100px', display: 'none'}}></div>

						<center>
							<div className="button_outer {fileUploading ? 'file_uploading' : ''} {fileUploaded ? 'file_uploaded' : ''}" onClick={HandleUploadStatusChange} >

								<div className="btn_upload" style={{fontWeight: 'normal'}}>
									<input type="file" id="upload_file" name="" onChange={(evt) => displayFile(evt)} />Attach File?
								</div>
								<div className="processing_bar"></div>
								<div className="success_box"></div>

							</div>
						</center>

					</div>

					<div className="error_msg"></div>
					<div className="uploaded_file_view" id="uploaded_view">
						<span className="file_remove">X</span>
					</div>

				{/* Hide user info input fields if team project */}

					{/* { teamProject_state == true ? 
						($(".skip-blockchain-switch").hide(200), handleContinueClick()
						) : (<br/>)
					}
					{ teamProject_state == true ? 
						(<div style={{ margin:'-25px 0px 0px'}}></div>
						) : ("")
					} */}

				{/* Ask using blockchain or not */}

					<div className='skip-blockchain-switch' style={{ margin: "20px 8px 0px", maxWidth:'350px', display:'inline-block' }}>
						<div style={{ lineHeight:'1.7', fontSize:'15px', color:'lightgray', display:'inline-block' }}>
							<Switch
								checked={skipBlockchain}
								onChange={handleSkipBlockchainSwitch}
								inputProps={{ 'aria-label': 'controlled' }}
							/>
							Skip blockchain
						</div>
					</div>

					<div className='team-project-notice' style={{ border:'0px solid red', margin:'auto', marginTop: "60px", marginBottom:'-30px', maxWidth:'490px', lineHeight:'1.7', fontSize:'16px', color:'lightgreen', display:'none' }}>
						Make sure you're a team member
					</div>

					<div className='chain-explanation' style={{ margin:'auto', marginTop:'0px', marginBottom:'5px', maxWidth:'420px', fontSize:'14px', color:'rgb(168, 168, 168)', lineHeight:'1.6' }}>
						This project accepts unofficial, off-chain participants
					</div>

				{/* "Continue" button */}

					<Box sx={{ '& > button': { m: 1 } }} style={{ padding:"5px", display:'inline-block' }}>
						<Button className='continue-button' variant="text" size='large' onClick={ handleContinueClick }>
							&gt; &gt; Click When Ready &lt; &lt;
							{/* {saveType=='offchain' ? <span>Continue off-chain</span> : <span>Continue on-chain</span>} */}
						</Button>
					</Box>

				{/* First time participating or not */}

					<div className='new-or-returning' style={{ display:'none'}} >
						<div style={{ marginTop:'20px', marginBottom:'0px', lineHeight:'1.5', color:'lightgray', display:'inline-block '}}>
							Have you already created a non-blockchain account here?
						</div>
						<div style={{ marginBottom:'15px', display:'inline-block '}}>
							<Button variant="text" size="large" onClick={ () => handleNewOrNotClick('returning') }>YES</Button>
							<Button variant="text" size="large" onClick={ () => handleNewOrNotClick('new') }>NO</Button>
						</div>
					</div>

				{/* User information input fields */}

					<Box
						className='user-info-input-section'
						component="form"
						sx={{
							'& > :not(style)': { m: 1, width: '27ch' },
						}}
						noValidate
						autoComplete="off"
						style={{ display:'none' }}
					>

						<TextField 
							className="username-field"
							id="username-field" 
							label="Username" 
							helperText="Secondary to your wallet address"
							variant="standard" 
							value={newUsername}
							style={{ maxWidth:'200px' }}
							error={errorNewUsername} 
							onChange={(event) => {setNewUsername(event.target.value)}} />

						<TextField 
							className="password-field"
							id="password-field" 
							label="Password" 
							helperText="Required only for off-chain users"
							variant="standard" 
							value={newUserPassword}
							style={{ maxWidth:'200px' }}
							error={errorNewUserPassword} 
							onChange={(event) => {setNewUserPassword(event.target.value)}} />

						<TextField 
							className="email-field"
							id="email-field" 
							label="Email" 
							helperText="Will be kept private & off-chain"
							variant="standard"
							value={newUserEmail}
							style={{ maxWidth:'200px' }}
							error={errorNewUserEmail} 
							onChange={(event) => {setNewUserEmail(event.target.value)}} />
					</Box>

				{/* Alerts * * * */}
					<center className='hyperlink' style={{lineHeight:'1.6'}}>

					<div className='user-bchain-unrecognized input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 166, 166)', fontSize:'15px', display:'none'}}>Your blockchain address is new to the system. Switch to a registered blockchain account or register the currently active one by choosing a public username above. Your email will be kept off-chain, private, and changeable.</div>

					<div className='user-name-unrecognized input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 166, 166)', fontSize:'15px', display:'none'}}>
						The username is new to the system. Please check for misspelling or 
						<a href="#" onClick={ (event) => { event.preventDefault(); handleNewOrNotClick('new'); } }> register a new username</a>. 
						(Note: Your email will be kept off-chain, private, and changeable).
					</div>

					<div className='user-password-incorrect input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 166, 166)', fontSize:'15px', display:'none'}}>Your password is incorrect.</div>

					<div className='username-unavailable input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This username belongs to someone else! Please choose a different name.</div>

					<div className='user-email-unavailable input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This email address is used by someone else! Please use a different one.</div>

					<div className='username-unavailable-check-pw input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>The username belongs to someone who registered it WITHOUT blockchain. If it is you, please enter the password for it so you can reuse it.</div>

					<div className='onchain-user-pw-check-fail input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>Your password was incorrect. Please choose a different username or enter a correct password for the the same username.</div>

					<div className='username-unavailable-check-bchain input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>The username belongs to someone who registered it with a blockchain address. If it was you, please <a href="#" onClick={connectWallet}>connect your wallet </a> and re-try so we can verify it & you can reuse it.</div>

					<div className='username-unavailable-check-bchain-fail input-alert-area' style={{ margin:'10px 0px 38px', maxWidth:'500px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>The username belongs to someone who registered it with a blockchain address. Choose a different username or if it was you who registered it, connect to the correct blockchain/wallet account and retry (your current account does not match the one registered with the username).</div>

					</center>
				{/* End Alerts * * * */}


				{/* Submit Button - OFF-chain */}

				<center className='offchain-submit-button' style={{ marginTop:'30px', marginBottom:'30px', display:'none' }}>

					<div className='vertical-adj-1' style={{display: 'none'}}></div>
					
					<div className='width-control-1' style={{margin: 'auto', margin: '10px 0px 30px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '500px'}}></div>

					<Button variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)'}} disabled={ submitBtnDisabled } onClick={ checkBeforeSaving }>
						Submit To Server
					</Button>

				</center>

				{/* Submit Button - BLOCKCHAIN */}

				{/* <center className='connect-wallet-button' style={{ marginTop:'30px', marginBottom:'30px', display:'none' }}> */}
				<center className='bchain-button-section' style={{ marginTop:'30px', marginBottom:'30px', display:'none' }}>

					<div className='vertical-adj-1' style={{display: 'none'}}></div>
					
					<div className='width-control-1' style={{margin: 'auto', margin: '10px 0px 30px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '500px'}}></div>

					<Button className='bchain-button' variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ submitBtnDisabled } onClick={ checkBeforeSaving }>
						Save to Blockchain
					</Button>

					<Button className='connect-wallet-button' variant='contained' style={{backgroundColor: 'rgb(207, 154, 151)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'block'}} disabled={ submitBtnDisabled } onClick={ connectWallet }>
						Connect (Blockchain)
					</Button>

					<Button className='switch-chain-button' variant='contained' style={{backgroundColor: 'rgb(239, 223, 143)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ submitBtnDisabled } onClick={ switchNetwork }>
						Switch Network
					</Button>

					<Box id='bchain-progress' style={{display: 'none'}}>
						<br/><div style={{ color:'white'}}>Please wait...</div><br/>
						<CircularProgress />
					</Box>

					{/* Blockchain help text */} 

						<div className="bchain-help-section" style={{display:"none"}}>

							<HelpOutline 
								className = "width-control-1 width-control-2"
								onClick={HandleBchainInfoClick}
								sx={{
									'& > :not(style)': { m: 0 },
									color: "lightblue",
									width: 300, // 30
									maxWidth: '100%',
									margin: "auto",
									// marginTop: "-17x",
									marginBottom: "-19px",
									marginLeft: "94px",
									fontSize: "20px",
									border: "0px solid green",
								}} 
							/> 

							<div style={{ border:"0px solid red", maxWidth: '405px', margin: 'auto', color: 'rgb(200, 200, 200)', fontSize:"15px" }}>
								<center style={{ marginTop:"-4px", marginLeft:"-21px"}}>
									What is this?
								</center>
							</div>

							<div id='blockchain-help-info' className='hyperlink' style={{border: '0px solid red', margin: 'auto', marginTop: '18px', maxWidth: '495px', padding:'0px 10px', color: 'lightgray', fontSize: '16px', lineHeight:'1.5', textAlign: 'left', display: 'none'}}></div>

						</div>
					{/* end blockchain help text */}

				</center>

			</div>
			</div>
			</div> {/* end 'mainBoxesVisible' */}

			{/* End user psi info submission section */}

			<div className='data-submission-section main-boxes'><br/></div>
		
			{/* ------------------------------------ */}


		{/* horizontal line */}
		<center>
			<div className='data-submission-section width-control-1 main-boxes' style={{margin: 'auto', margin: '20px 0px 46px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '635px'}}></div>
		</center>


		{/* Inner gray box */}

		<div className='main-boxes' style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px 18px 50px' }}>

			<br/>
			<div className='subheading' style={{ marginBottom:'20px', fontSize:'22px' }}>PROJECT DETAIL</div>


			{/* Blockchain note */}
				<div className='header-texts' style={{margin:'16px 0px -15px', color: 'rgb(131, 214, 185)', fontWeight: 'normal', fontSize: '16px', wordBreak: 'break-word', lineHeight: 1.7, display:'none'}}>
					Retrieved From Blockchain
				</div>
				<div className='retrieval-error-note' style={{margin:'10px 0px -5px', color: 'rgb(245, 96, 66)', fontWeight: 'normal', fontSize: '16px', wordBreak: 'break-word', lineHeight: 1.7, display:'none'}}>
					Data could not be retrieved from blockchain.
					{ cfmMode == true ?  (<span><br/>Try reloading page.</span>) : ( <span></span> ) }
				</div>

			{/* Loading icon */}
				<div id="loading-motion-2" style={{ margin:'35px 0px -15px', display: 'none'}}></div>

			{/* Tables */}
    
				<TableContainer className='hyperlink'>

					{/* Table #1 - Tasking text & hash rows (2)  */}

					<Table sx={{ maxWidth: 640, margin: "auto" }} aria-label="spanning table">

						<TableHead>
							<TableRow>
								<TableCell align="center" colSpan={2}></TableCell>
							</TableRow>
						</TableHead>

						<TableBody style={{ border:'0px solid yellow'}}>

							<TableRow style={{ border:'0px solid red', wordBreak: 'break-word', lineHeight: 1.7}}>

								<TableCell className="browse-table-cell-ctr-1" align="left" style={{ borderBottom:'1px solid rgb(102, 102, 102)', backgroundColor: 'rgba(255, 255, 255, 0.04)', fontWeight: 'bold' }}>
									TASKING:
								</TableCell>

								<TableCell className="browse-table-cell-ctr-1b" align="left" width="85%" style={{ borderBottom:'1px solid rgb(102, 102, 102)', paddingRight:'15px', textAlign:'left' }} >
								
									<div className='tasking-label-mobile' align="center" style={{ display:'none' }}>
										TASKING:
									</div>
									
									<div className='tasking-align-control' style={{ textAlign:'left', fontSize:'14px', color:'lightgray', display: feedbackShown == false ? 'block' : 'none'}}>
										{ projectInfo_onchain.psiTaskingHash ? (
											projectInfo_onchain.psiTaskingHash
										) : ( 
											"-----"
										)}
									</div>
									
									<div className='tasking-align-control' style={{ textAlign:'left', fontSize:'15px', fontWeight:'bold', color:'rgb(216, 216, 216)', display: feedbackShown == true ? 'block' : 'none' }}>

										<div dangerouslySetInnerHTML={{ __html: feedbackTasking }} style={{ lineHeight:'1.6', display:'inline-block'}} />

										{ feedbackFilename == null ? ( <div></div> ) : (
											<div><a href={UPLOADS_FOLDER_URL + feedbackFilename} target="_blank" rel="noopener noreferrer">
												<Button variant="outlined" size="small" style={{ margin:'7px 0px 0px 0px' }}>
													Attached File
												</Button>
											</a></div>
										)}

									</div>
								</TableCell>
							</TableRow>

							{ feedbackShown == false && projectInfo_onchain.projectFileHash ? (

								<TableRow style={{ border:'0px solid red', borderBottom:'1px solid rgb(102, 102, 102)', wordBreak: 'break-word', lineHeight: 1.7 }}>
								
									<TableCell className="browse-table-cell-ctr-1" align="left" style={{ border:'0px solid yellow', backgroundColor: 'rgba(255, 255, 255, 0.04)', fontWeight: 'bold'}}>
										TASKING FILE:
									</TableCell>

									<TableCell className="browse-table-cell-ctr-1b" align="left" width="85%" style={{ border:'0px solid green', paddingRight:'15px' }} >

										<div className='tasking-label-mobile' align="center" style={{ display:'none' }}>
											TASKING FILE:
										</div>

										<div className='tasking-align-control' style={{ fontSize:'14px', color:'lightgray' }}>
											{projectInfo_onchain.projectFileHash}
										</div>

									</TableCell>
								</TableRow>	

							) : ( "" )}



							{ feedbackShown == true ? (

								<TableRow style={{ border:'0px solid red', borderBottom:'1px solid rgb(102, 102, 102)', wordBreak: 'break-word', lineHeight: 1.7 }}>

									<TableCell className="browse-table-cell-ctr-1" align="left" style={{ color:'rgb(163, 163, 163)', border:'0px solid yellow', backgroundColor: 'rgba(255, 255, 255, 0.04)', fontWeight: 'bold'}}>
										TASKING HASH:
									</TableCell>

									<TableCell className="browse-table-cell-ctr-1b" align="left" width="85%" style={{ border:'0px solid green', paddingRight:'15px' }} >

										<div className='tasking-label-mobile' align="center" style={{ color:'rgb(163, 163, 163)', display:'none' }}>
											TASKING HASH:
										</div>

										<div className='tasking-align-control' style={{ fontSize:'14px', color:'rgb(163, 163, 163)' }}>
											{projectInfo_onchain.psiTaskingHash}
										</div>

									</TableCell>
								</TableRow>	

							) : ( "" )}

							{ feedbackShown == true && projectInfo_onchain.projectFileHash ? (

								<TableRow style={{ border:'0px solid red', borderBottom:'1px solid rgb(102, 102, 102)', wordBreak: 'break-word', lineHeight: 1.7 }}>

									<TableCell className="browse-table-cell-ctr-1" align="left" style={{ color:'rgb(163, 163, 163)', border:'0px solid yellow', backgroundColor: 'rgba(255, 255, 255, 0.04)', fontWeight: 'bold'}}>
										FILE HASH:
									</TableCell>

									<TableCell className="browse-table-cell-ctr-1b" align="left" width="85%" style={{ border:'0px solid green', paddingRight:'15px' }} >

										<div className='tasking-label-mobile' align="center" style={{ color:'rgb(163, 163, 163)', display:'none' }}>
											FILE HASH:
										</div>

										<div className='tasking-align-control' style={{ fontSize:'14px', color:'rgb(163, 163, 163)' }}>
											{projectInfo_onchain.projectFileHash}
										</div>

									</TableCell>
								</TableRow>	

							) : ( "" )}

						</TableBody>
					</Table>

					<div style={{ maxWidth: '620px', margin: 'auto', marginTop: '5px', marginBottom: '8px', marginLeft:'4px', color: 'rgb(247, 176, 176)', fontSize:'15px', lineHeight: '1.5', textAlign:'left', display: feedbackShown == true ? 'none' : 'block' }}>
						{ projectInfo_onchain.timeStamp && (
							"Only 'hash' (cryptographic 'fingerprint') of tasking is shown until project closes."
						)}
					</div>

					{/* <div style={{maxWidth: '620px', margin: 'auto', marginTop: '5px', marginBottom: '8px', marginLeft:'7px', color: 'rgb(163, 163, 163)', fontSize:'15px', lineHeight: '1.5', textAlign:'left', display: feedbackShown == true ? 'block' : 'none' }}>The hash of the tasking is on blockchain for verification (check "Transaction" below).</div> */}

					<div style={{maxWidth: '620px', margin: 'auto', marginBottom: '50px', marginLeft:'7px', color: 'rgb(163, 163, 163)', fontSize:'15px', lineHeight: '1.5', textAlign:'left', display: feedbackShown == true ? 'block' : 'none' }}>
					</div> 


				{/* Table 1B - Rest of the rows */}

					{/* gray horizontal line */}
					<div style={{margin: 'auto', margin: '20px 0px 0px', borderTop: '1px rgb(82, 82, 82) solid', maxWidth: '700px'}}></div>

					<Table sx={{ maxWidth: 640, margin: "auto" }} aria-label="spanning table">

						<TableBody>

							{rows.map((row) => (

								<TableRow key={row.label} style={{wordBreak: 'break-word', lineHeight: 1.7}}>

									<TableCell className="browse-table-cell-ctr-2" align="left" style={{ fontWeight:'normal', color:'lightgray'}}>
										{row.label}:
									</TableCell>

									<TableCell className="browse-table-cell-ctr-2b" align="left">

										{/* Primary value in cell */}

											{/* Normal ones */}
											{ row.label !== "PROJ MANAGER" && row.label !== "FILE LINK" && row.label !== "FILE HASH" && row.label !== "PROJECT KEY" && row.label !== "PRIVATE MODE" ? (
												<div style={{ display:'inline-block' }}>
													{row.value}
												</div>
												) : ( "" )
											}

											{/* Specific */}
											{ row.label === "PROJ MANAGER" ? (
												<div style={{ display:'inline-block' }}>
													{/* <a href={teamURL_state} target='_blank'>
														{row.value}
													</a> */}
													{row.value}
													<br/><div style={{ marginLeft:'0px', fontSize:'13px', color:'rgb(191, 191, 191)', display: 'inline-block' }}>
														({projectInfo_onchain.managerAddress})
													</div>
												</div>
												) : ( "" )
											}

											{ row.label === "PROJECT KEY" ? (
												<div style={{ color:'rgb(191, 191, 191)', fontSize:'13px' }}>
													{row.value}
												</div>
												) : ( "" )
											}

											{ row.label === "PRIVATE MODE" ? (
												<div style={{ whiteSpace:'pre', display:'inline-block', wordBreak: 'break-word' }}>
													{privacyText_state}
												</div>
												) : ( "" )
											}

											
										{/* Secondary value in cell & special ones */}

											{ row.label == "PROJECT FOR" && row.value != "ALL (open project)" && row.value != "YOU only" ? (
												<div style={{display:'inline-block'}}>

													<div style={{ marginLeft:'8px', display:'inline-block' }}>

														"<a href={teamURL_state} target='_blank'>
															{projectInfo_offchain.team_name}
														</a>"
													</div>
												</div>
												) : ("") 
											}

											{ row.label === "PROJECT TXN" ? (
												<div style={{display:'inline-block'}}>
													<div style={{ display:'inline-block' }}>

														<a href={projTxnURL} target="_blank" rel="noopener noreferrer">
															<Button variant="outlined" size="small" style={{ margin:'3px 8px 3px 4px' }}>
																TRANSACTION
															</Button>
														</a>

														<div style={{ marginLeft:'5px', marginTop:'5px', fontSize:'14px', display:'inline-block'}}>
															[<a href='https://psiscope.com/how-to-audit-project-type-1-onchain-data/' target='_blank' style={{ margin:'3px 2px 0px'}}>
																How to check
															</a>]

														</div>
													</div>
												</div>
												) : ("") 
											}

									</TableCell>

								</TableRow>
							))}

						</TableBody>

					</Table>

				</TableContainer>

		</div>
		{/* end of inner gray box */}


		{/* horizontal line - PRIVACY MODE section */}
			<center>
				<div className='width-control-1 privacy-box' style={{margin: 'auto', margin: '40px 0px 40px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '635px'}}></div>
			</center>

		{/* Inner gray box */}

			<div className='privacy-box' style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px 18px 30px' }}>
				<br/>

				<div className='subheading' style={{ marginBottom:'20px', fontSize:'22px' }}>PRIVACY MODE</div>

				<div style={{border:'0px solid yellow', maxWidth: '570px', margin:'auto', marginTop: '11px', marginBottom: '0px', color: 'rgb(211, 211, 211)', lineHeight: '1.5', textAlign:'center' }}>

					<div style={{border:'0px solid yellow', wordBreak: 'break-word' }}> {privacyText_state} </div>

					<div className = "setting-switch" style={{ marginTop:'7px' }}>

						<div style={{ display:'inline-block' }}>
						{privateStatus_state === true ? (
							"(You can turn off privacy"
							) : (
							"(You can turn on privacy"
							)
						}
						</div>

						<div style={{ display:'inline-block'}}>
							<FormGroup 
								sx={{
									'& > :not(style)': { m: 0 },
									border: '0px solid blue'
								}}>

								<FormControlLabel style={{ color: "lightgray", display:'inline-block' }}
								control={<Switch size="small" checked={privateStatus_state} onChange={(event) => {switchPrivateMode(event.target.checked)}} />} label="" />
							</FormGroup>
						</div>

						<div style={{ display:'inline-block' }}>
							)
						</div>

					</div>
				</div>
			</div>


		<br/>

		{/* horizontal line - SUBMITTED PSI DATA section */}
		<center>
			<div className={'width-control-1 main-boxes'} style={{margin: 'auto', margin: '20px 0px 46px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '635px'}}></div>
		</center>


		{/* Inner gray box */}

		<div id='submission-list-table' className={'hyperlink main-boxes'} ref={userSubmissionsTable} style={{ margin:"auto", marginBottom:"10px", maxWidth:'608px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025', padding:'15px 18px 50px' }}>

			<br/>
			<div className='subheading' style={{ marginBottom:'0px', fontSize:'22px' }}>SUBMITTED PSI DATA</div>

			{/* Collapsible Table */}
				<br/><br/>
				<TableContainer component={Paper} style={{ maxWidth:'650px', margin:'auto' }}>
					<Table aria-label="collapsible table">
						<TableHead>
							<TableRow>
								<TableCell />
								<TableCell>Username</TableCell>
								<TableCell align="center">Time (UTC)</TableCell>
								<TableCell align="center">Onchain</TableCell>
								{/* <TableCell align="right">Carbs&nbsp;(g)</TableCell> */}
							</TableRow>
						</TableHead>
							<TableBody>
								{rows2.map((currentRow) => (
									<Row key={currentRow.readableTime} rowReadableTime={currentRow.readableDate} table2Row={currentRow} showLatestSubmission={showLatestSubmission}  />
								))}
							</TableBody>
					</Table>
				</TableContainer>
		</div>
		{/* End of inner gray box */}


			<ThemeProvider theme={dimtheme}>
				<Box sx={{ '& button': { m: 1 } }}>
					<div style={{ marginTop:'27px'}}>
						<Button variant="outlined" size="small" color="neutral" onClick={copyURL}>
							{copyText}
						</Button>
					</div>
				</Box>
			</ThemeProvider>

		</div> {/* end of gray box */}

		{/* </div> end of container */}

		</ThemeProvider>
		<br/><br/><br/><br/>
    </div>

  );
}

